/* globals Raven */
/* eslint moduleName:0 */

"use strict";

(function () {
  var itsoftApp;
  var pageHeader = document.querySelector(".page-header");
  var pageHeaderContent = pageHeader.querySelector(".page-header__content");
  var disclaimer = document.querySelector(".disclaimer, .warning_block"); // #warningHTML для OTC
  var cookie = document.querySelector(".js-cookies");
  var slice = [].slice;
  var noScript = document.querySelector("[data-no-script]");
  if (noScript) {
    noScript.removeAttribute("data-no-script");
  }
  var hash = location.hash;
  var hashElement = hash ? document.querySelector(hash) : null;
  window.itsoftApp = itsoftApp = {
    createNS: function createNS(namespace) {
      var i, len, nsparts, parent, part;
      nsparts = namespace.split(".");
      parent = itsoftApp;

      // we want to be able to include or exclude the root namespace so we strip
      // it if it's in the namespace
      if (nsparts[0] === "itsoftApp") {
        nsparts = nsparts.slice(1);
      }

      // loop through the parts and create a nested namespace if necessary
      for (i = 0, len = nsparts.length; i < len; i++) {
        part = nsparts[i];

        // check if the current parent already has the namespace declared
        // if it isn't, then create it
        if (typeof parent[part] === "undefined") {
          parent[part] = {};
        }

        // get a reference to the deepest element in the hierarchy so far
        parent = parent[part];
      }
      return parent;
    },
    state: {
      hash: hash,
      hashElement: hashElement,
      hashActive: hash && hashElement,
      сheckListElementsToBeUpdatedDuringResizing: {
        "headerHeight": false,
        "disclaimerHeight": false,
        "viewWidth": false,
        "viewHeight": false,
        "cookieHeight": false,
        "footerTopCoordRelToDocument": false
      }
    },
    calculations: {
      headerHeight: null,
      headerStaticHeight: null,
      headerFixedHeight: null,
      viewWidth: null,
      viewHeight: null,
      cookieHeight: null,
      disclaimerHeight: null,
      footerTopCoordRelToDocument: null
    },
    isLocal: !!document.getElementById("js-server-local"),
    libraries: {
      gsap: {
        name: "gsap",
        queue: [],
        started: false,
        loaded: false,
        script: "/assets/scripts/gsap/gsap.min.js",
        cb: function cb() {
          DEBUG && console.log("GSAP");
        }
      },
      scrollTrigger: {
        name: "scrollTrigger",
        queue: [],
        started: false,
        loaded: false,
        dependency: "gsap",
        script: "/assets/scripts/gsap/ScrollTrigger.min.js",
        cb: function cb() {
          gsap.registerPlugin(ScrollTrigger);
        }
      },
      scrollToPlugin: {
        name: "scrollTo",
        active: null,
        queue: [],
        started: false,
        loaded: false,
        dependency: "gsap",
        script: "/assets/scripts/gsap/ScrollToPlugin.min.js",
        cb: function cb() {
          gsap.registerPlugin(ScrollToPlugin);
        }
      },
      smoothScroll: {
        name: "smoothScroll",
        queue: [],
        started: false,
        loaded: false,
        script: "/assets/scripts/smoothScroll/smooth-scroll.min.js"
      },
      slider: {
        name: "swiper",
        queue: [],
        started: false,
        loaded: false,
        style: "/assets/scripts/swiper/swiper.min.css",
        script: "/assets/scripts/swiper/swiper.min.js",
        cb: function cb() {
          Swiper.initedSliders = {};
        }
      }
    },
    utils: {
      debouncer: function debouncer(func, timeout) {
        var timeoutID;
        if (timeout == null) {
          timeout = 200;
        }
        timeoutID = undefined;
        return function () {
          var args, scope;
          scope = this;
          args = arguments;
          clearTimeout(timeoutID);
          timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
          }, timeout);
        };
      },
      throttler: function throttler(func, ms) {
        var isThrottled = false,
          savedArgs,
          savedThis;
        function wrapper() {
          if (isThrottled) {
            // (2)
            savedArgs = arguments;
            savedThis = this;
            return;
          }
          func.apply(this, arguments); // (1)

          isThrottled = true;
          setTimeout(function () {
            isThrottled = false; // (3)
            if (savedArgs) {
              wrapper.apply(savedThis, savedArgs);
              savedArgs = savedThis = null;
            }
          }, ms);
        }
        return wrapper;
      },
      // Stealed from
      // https://github.com/VodkaBears/Remodal
      getScrollbarWidth: function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      },
      // TODO
      // REPAINT
      // Вызывает Recalculate Style
      // Проверить, из-за чего, и можно ли избавиться
      getScrTop: function getScrTop() {
        var $body, $document, $wrapper, scrTop;
        $document = itsoftApp.commonVars.$document;
        $body = itsoftApp.commonVars.$body;
        $wrapper = itsoftApp.commonVars.$wrapper;
        scrTop = Math.max($document.scrollTop, $body.scrollTop, $wrapper.scrollTop, 0); //pageYOffset
        // console.log($document.scrollTop(), $body.scrollTop(), $wrapper.scrollTop())
        return scrTop;
      },
      getTime: function () {
        var res;
        if (window.performance && typeof window.performance.now === "function") {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }
            return parseFloat(window.performance.now().toFixed(precision));
          };
        } else {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }
            return parseFloat(new Date().getTime().toFixed(precision));
          };
        }
        return res;
      }(),
      newMeasureFunc: function newMeasureFunc(precision) {
        var res, t0;
        if (precision == null) {
          precision = 2;
        }
        t0 = itsoftApp.utils.getTime(precision);
        res = function res() {
          var t1, t2;
          t1 = itsoftApp.utils.getTime(precision);
          t2 = parseFloat((t1 - t0).toFixed(precision));
          t0 = t1;
          return t2;
        };
        return res;
      },
      getInitTimes: function getInitTimes() {
        var k, module, obj, ref, total;
        obj = {};
        total = 0;
        ref = itsoftApp.modules;
        for (k in ref) {
          module = ref[k];
          if (module.initialized && module.__mName__ !== undefined) {
            obj[module.__mName__] = module.__initTime__;
            total += module.__initTime__;
          }
        }
        obj.all = Math.round(total);
        return obj;
      },
      checkIsSafari: function checkIsSafari() {
        var UA = navigator.userAgent.toLowerCase();
        if (UA.indexOf("safari") != -1) {
          if (UA.indexOf("chrome") > -1) {
            return;
          } else {
            return true;
          }
        }
      },
      getViewportSize: function getViewportSize() {
        if (itsoftApp.utils.checkIsSafari()) {
          itsoftApp.calculations.viewWidth = document.documentElement.clientWidth;
        } else {
          itsoftApp.calculations.viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }
        DEBUG && console.log(itsoftApp.calculations.viewWidth, "VIEWPORT");
        return itsoftApp.calculations.viewWidth;
      },
      getViewportHeight: function getViewportHeight() {
        itsoftApp.calculations.viewHeight = document.documentElement.clientHeight;
        DEBUG && console.log(itsoftApp.calculations.viewHeight, "VIEWHEIGHT");
        return itsoftApp.calculations.viewHeight;
      },
      getHeaderFixedHeight: function getHeaderFixedHeight() {
        if (pageHeader.classList.contains("js-fixed")) {
          DEBUG && console.log("FIXED");
          itsoftApp.calculations.headerFixedHeight = itsoftApp.calculations.headerHeight;
        } else {
          if (pageHeaderContent) {
            pageHeaderContent.style.transition = "none";
          }
          pageHeader.classList.add("js-fixed");
          itsoftApp.calculations.headerFixedHeight = pageHeader.offsetHeight;
          pageHeader.classList.remove("js-fixed");
          if (pageHeaderContent) {
            pageHeaderContent.style.transition = "";
          }
        }
      },
      getHeaderStaticHeight: function getHeaderStaticHeight() {
        if (!pageHeader.classList.contains("js-fixed")) {
          DEBUG && console.log("STATIC");
          itsoftApp.calculations.headerStaticHeight = itsoftApp.calculations.headerHeight;
        } else {
          if (pageHeaderContent) {
            pageHeaderContent.style.transition = "none";
          }
          pageHeader.classList.remove("js-fixed");
          itsoftApp.calculations.headerStaticHeight = pageHeader.offsetHeight;
          pageHeader.classList.add("js-fixed");
          if (pageHeaderContent) {
            pageHeaderContent.style.transition = "";
          }
        }
      },
      getHeaderHeight: function getHeaderHeight() {
        itsoftApp.calculations.headerHeight = pageHeader.offsetHeight;
        DEBUG && console.log(itsoftApp.calculations.headerHeight, "HEADERHEIGHT");
        return itsoftApp.calculations.headerHeight;
      },
      getCookieHeight: function getCookieHeight() {
        itsoftApp.calculations.cookieHeight = cookie && cookie.offsetHeight;
        DEBUG && console.log(itsoftApp.calculations.cookieHeight, "cookieHeight");
        return itsoftApp.calculations.cookieHeight;
      },
      getDisclaimerHeight: function getDisclaimerHeight() {
        itsoftApp.calculations.disclaimerHeight = disclaimer && disclaimer.offsetHeight;
        DEBUG && console.log(itsoftApp.calculations.disclaimerHeight, "disclaimerHeight");
        return itsoftApp.calculations.disclaimerHeight;
      },
      getCoordsRelPage: function getCoordsRelPage(el) {
        var box = el.getBoundingClientRect();
        return {
          top: box.top + pageYOffset,
          left: box.left + pageXOffset
        };
      },
      supportWebP: function supportWebP(callback) {
        var webP = new Image();
        webP.onload = function () {
          callback(webP.height === 1);
        };
        webP.onerror = function () {
          callback(false);
        };
        // Использование маленькой и прозрачной картинки WebP для проверки
        webP.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMw' + 'AgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
      }
    },
    loadScript: function loadScript(url, callback, error) {
      var script;
      script = document.createElement("script");

      // If "fallback" url passed as second argument
      var args = Array.prototype.slice.call(arguments);
      if (typeof callback === "string") {
        var fallbackUrl = callback;
        callback = error;
        var errorOri = args[3];
        error = function error() {
          DEBUG && console.log("%c[common] error while loading script: " + url + ". trying to load a fallback url: " + fallbackUrl, "color: red");
          itsoftApp.loadScript(fallbackUrl, callback, errorOri);
          if (!DEBUG && typeof Raven !== "undefined") {
            Raven.captureMessage("[common] error while loading script", {
              level: "warning",
              // one of 'info', 'warning', or 'error'
              extra: {
                "script": url,
                "fallback": fallbackUrl
              }
            });
          }
        };
      }
      var cb = function cb() {
        DEBUG && console.log("%c--[common] finished loading script: " + url, "color: #999");
        if (typeof callback === "function") {
          callback();
        }
      };

      // IE
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            cb();
          }
        };

        // Normal browsers
      } else {
        if (typeof error === "function") {
          script.onerror = error;
        }
        script.onload = cb;
      }
      script.src = url;
      document.getElementsByTagName("body")[0].appendChild(script);
      DEBUG && console.log("%c--[common] starting to load script: " + url, "color: #999");
    },
    loadStyle: function loadStyle(url) {
      var first, head, link;
      link = document.createElement("link");
      link.href = url;
      link.rel = "stylesheet";
      link.type = "text/css";
      head = document.getElementsByTagName("head")[0];
      first = head.firstChild;

      // Prepend styles in 'head' section
      head.insertBefore(link, first);
    },
    features: {
      // From Modernizr
      transitionEventEnd: function () {
        var el, t, transitions;
        el = document.createElement("fakeelement");
        transitions = {
          "transition": "transitionend",
          "OTransition": "oTransitionEnd",
          "MozTransition": "transitionend",
          "WebkitTransition": "webkitTransitionEnd"
        };
        for (t in transitions) {
          if (el.style[t] !== undefined) {
            el = null;
            return transitions[t];
          }
        }
        return false;
      }()
    },
    modules: {},
    initializedModules: [],
    createModule: function createModule() {
      var dep, dependencies, i, initFunc, j, len, mName, module, options, ref;
      mName = arguments[0], options = 3 <= arguments.length ? slice.call(arguments, 1, i = arguments.length - 1) : (i = 1, []), initFunc = arguments[i++];
      if (typeof initFunc !== "function") {
        throw "Missing an initialization function for module '" + mName + "'";
      }

      // Create a namespace
      module = itsoftApp.createNS("modules." + mName);
      module.__mName__ = mName;
      module.initialized = false;

      // Set dependencies
      if (options.length && options[0].length) {
        dependencies = [];
        ref = options[0];
        for (j = 0, len = ref.length; j < len; j++) {
          dep = ref[j];
          if (typeof dep === "string" && dependencies.indexOf(dep) < 0 && dep !== mName) {
            dependencies.push(dep);
          }
        }
        if (dependencies.length) {
          module.dependencies = dependencies;
        }
      }

      // Set initialization function and behavior
      module.init = function () {
        var depModule, e, initTime, initializedModules, l, len1, t1, t2;
        try {
          if (module.dependencies) {
            for (l = 0, len1 = dependencies.length; l < len1; l++) {
              dep = dependencies[l];
              depModule = itsoftApp.modules[dep];
              if (!depModule) {
                DEBUG && console.log("%c[modules] missed module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
              if (depModule.initialized) {
                continue;
              }
              depModule.init();
              if (!depModule.initialized) {
                DEBUG && console.log("%c[modules] can't init module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
            }
          }
          t1 = itsoftApp.utils.getTime();
          if (initFunc.call(module) !== false) {
            t2 = itsoftApp.utils.getTime();
            initTime = parseFloat((t2 - t1).toFixed(1));
            module.__initTime__ = initTime;
            DEBUG && console.log("[module " + mName + "] module initialized in " + initTime + " ms");
            module.initialized = true;
            initializedModules = itsoftApp.initializedModules || [];
            initializedModules.push(mName);
            itsoftApp.initializedModules = initializedModules;
          }
        } catch (error1) {
          e = error1;
          if (typeof Raven !== "undefined") {
            Raven.captureException(e);
          }
          itsoftApp.errorHandler(e, {
            moduleName: mName
          });
        }
      };
      return module;
    },
    errorHandler: function errorHandler(error, options) {
      var pre;
      pre = "[error]";
      if (options && options.moduleName) {
        pre += "[module " + options.moduleName + "]";
      }
      if (console && console.error) {
        console.error(pre + "\n" + error + "\nNavigator: " + window.navigator.userAgent);
      }
    }
  };

  // Unit-tests for itsoftApp object
  if (DEBUG && typeof mocha !== "undefined" && typeof describe === "function") {
    mocha.setup("bdd");
    describe("itsoftApp object tests", function () {
      it("Should be an object", function () {
        expect(itsoftApp).to.be.an("object");
      });
      it("Should contain a loadScript function", function () {
        expect(itsoftApp.loadScript).to.be.a("function");
      });
      it("Should contain a loadStyle function", function () {
        expect(itsoftApp.loadStyle).to.be.a("function");
      });
      it("We can create a deep namespace scope with a string like 'ns1.ns2.ns3'", function () {
        itsoftApp.createNS("ns1.ns2.ns3");
        expect(itsoftApp.ns1).to.be.an("object");
        expect(itsoftApp.ns1.ns2).to.be.an("object");
        expect(itsoftApp.ns1.ns2.ns3).to.be.an("object");
        delete itsoftApp.ns1;
      });
      it("initializedModules must be defined from the start", function () {
        expect(itsoftApp.initializedModules).to.be.an("array");
      });
      describe(".modules", function () {
        it("Should be a function to create modules", function () {
          expect(itsoftApp.createModule).to.be.a("function");
        });
        it("We can simply create a single module", function () {
          var module, testFunc;
          testFunc = function testFunc() {
            console.log("test module init");
          };
          var mName = "testmodule" + Math.round(Math.random() * 100);
          module = itsoftApp.createModule(mName, testFunc);
          expect(module).to.be.equal(itsoftApp.modules[mName]);
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
        it("We can't create a module without initialization function", function () {
          var module;
          module = function module() {
            itsoftApp.createModule("testmodule");
          };
          expect(module).to["throw"];
        });
        it("Each module must have an init function", function () {
          var module;
          for (module in itsoftApp.modules) {
            expect(itsoftApp.modules[module].init).to.be.a("function");
          }
        });
        it("Should throw an exception if we try to initialize a module twice", function () {
          var mName, module, testFunc;
          mName = "testmodule" + Math.round(Math.random() * 100);
          testFunc = function testFunc() {
            return 1;
          };
          module = itsoftApp.createModule(mName, testFunc);
          module.init();
          expect(module.init).to["throw"];
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
      });
    });
  }
  var itsoftAppInitFunc = function itsoftAppInitFunc() {
    var init = function init() {
      itsoftApp.commonVars = {
        dimensionsAndCoordsFlag: true,
        // отключить, если не нужно получать размеры и координаты страницы/окна в модули pageLoad и pageResize
        $document: document.documentElement,
        $body: document.body,
        $window: window,
        $wrapper: document.querySelector(".l-wrapper"),
        headerHeight: undefined,
        viewWidth: undefined
      };
      var benchmarkCloseBtn, benchmarkDiv, criticalInitTime, dColor, fTime, initTimes, m, module, moduleName, t, time, warningModules;
      if (DEBUG) {
        t = itsoftApp.utils.getTime();
      }
      itsoftApp.ajaxDisabled = false; //нужно для работы с аяксовыми переходами.

      itsoftApp.removeAllModules = function () {
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          module.initialized = false;
        }
        itsoftApp.initializedModules = [];
        DEBUG && console.log("%c[common] all modules removed", "font-weight: bold;");
      };
      itsoftApp.initAllModules = function () {
        // Initialize itsoftApp modules
        itsoftApp.removeAllModules();
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          if (!module.initialized && typeof module.init === "function") {
            module.init();
          }
        }
      };
      itsoftApp.initAllModules();
      if (DEBUG) {
        fTime = Math.round(itsoftApp.utils.getTime() - t);
        dColor = fTime < 200 ? "green" : "red";
        console.log("%c[common] document ready event fired, " + itsoftApp.initializedModules.length + " modules initialized in " + fTime + " ms: " + function () {
          var i, len, ref, results;
          ref = itsoftApp.initializedModules;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            m = ref[i];
            results.push(" " + m + "(" + itsoftApp.modules[m].__initTime__ + "ms)");
          }
          return results;
        }(), "color: " + dColor);
      }

      // Add benchmark div
      benchmarkDiv = document.getElementById("benchmark");
      if (typeof itsoftApp.utils.getInitTimes === "function" && (DEBUG || window.location.hash === "#benchmark") && !benchmarkDiv) {
        benchmarkDiv = document.createElement("div");
        benchmarkDiv.className = "benchmark";
        benchmarkDiv.id = "benchmark";
        if (typeof itsoftApp.utils.getInitTimes === "function") {
          benchmarkDiv.innerHTML = "<small style=\"opacity: 0.7\">modules (ms):" + function () {
            var ref, results;
            ref = itsoftApp.utils.getInitTimes();
            results = [];
            for (m in ref) {
              t = ref[m];
              results.push(" " + m + ": " + t);
            }
            return results;
          }() + "</small>";
        }

        // Add close button
        benchmarkCloseBtn = document.createElement("a");
        benchmarkCloseBtn.onclick = function () {
          benchmarkDiv.parentNode.removeChild(benchmarkDiv);
        };
        benchmarkCloseBtn.innerHTML = "X";
        benchmarkCloseBtn.className = "benchmark__close";
        benchmarkDiv.appendChild(benchmarkCloseBtn);
        // document.body.appendChild(benchmarkDiv);
      }

      // Check for "too complex" modules
      // WARNING иногда такие "ошибки" возникают спонтанно
      // (например, все модули инициализируются за 0-2 мс, а один "выстрелил" на 300 мс).
      // Если это станет мешать проектам, то можно данные предупреждения
      // из логгера убрать.
      if (!DEBUG && typeof Raven !== "undefined") {
        initTimes = itsoftApp.utils.getInitTimes();
        warningModules = [];
        criticalInitTime = 50;
        for (moduleName in initTimes) {
          time = initTimes[moduleName];
          if (moduleName === "all") {
            continue;
          }
          if (time > criticalInitTime) {
            warningModules.push(moduleName);
          }
        }

        //  CHANGED: Вот именно из-за того, что один из модулей может
        //  случайно инициализироваться за какое-то неадекватно большое для него время.
        //  if warningModules.length > 0
        if (warningModules.length > 1) {
          Raven.captureMessage("[common] detected some \"long\" (initTime > " + criticalInitTime + " ms) modules", {
            level: "warning",
            // one of 'info', 'warning', or 'error'
            extra: initTimes
          });
        }
      }

      // If unit tests library loaded, just load a file with tests
      if (typeof mocha !== "undefined") {
        mocha.setup("bdd");
        mocha.run();
      }
    };
    if ("addEventListener" in document) {
      init();
    }
  };

  // Document ready event
  if ("addEventListener" in document) {
    document.addEventListener("DOMContentLoaded", itsoftAppInitFunc, false);

    // .. IE <= 8
  } else if ("attachEvent" in document) {
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState === "complete") {
        itsoftAppInitFunc();
      }
    });
  }
})();
"use strict";

itsoftApp.createModule("accordion", function () {
  var module = this;
  var AccordionItem = function AccordionItem(accordionItemElement, ACCORDION) {
    this.ACCORDION = ACCORDION;
    this.state = {
      opened: accordionItemElement.classList.contains("js-accordion-item--active")
    };
    accordionItemElement.accordionItem = this;
    this.accordionItemElement = accordionItemElement;
    this.accordionHeadElement = accordionItemElement.querySelector(".js-accordion-head");
    this.accordionContentElement = accordionItemElement.querySelector(".js-accordion-content");
    this.accordionText = accordionItemElement.querySelector(".js-accordion-text");
    this.preventNone = this.accordionHeadElement.hasAttribute("data-prevent-none");
    this.once = this.accordionHeadElement.hasAttribute("data-once");
    this.init();
    accordionItemElement.instance = this;
  };
  AccordionItem.prototype.init = function () {
    var ACCORDION_ITEM = this;
    this.openListener = ACCORDION_ITEM.onOpenTransitionEnd.bind(ACCORDION_ITEM);
    this.closeListener = ACCORDION_ITEM.onCloseTransitionEnd.bind(ACCORDION_ITEM);
    this.accordionHeadElement.addEventListener("click", ACCORDION_ITEM.onAccordionClick.bind(ACCORDION_ITEM));
  };
  AccordionItem.prototype.onAccordionClick = function (evt) {
    if (!this.preventNone) {
      /* если специально не указан атрибут data-prevent-none, отменяем действие по умолчанию, например, переход по ссылке */
      evt.preventDefault();
    }

    /* если элемент аккордеона уже активен, скрываем его... */
    if (this.state.opened && this.ACCORDION.currentClosedItem == false) {
      if (this.ACCORDION.leastOne) {
        return;
      }
      this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
      this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
      this.ACCORDION.activeItem = "";
      this.closeAccordion();

      // if (this.ACCORDION.accordionType !== "any" && this.ACCORDION.activeItems.length === 0) {
      if (this.ACCORDION.activeItems.length === 0) {
        this.ACCORDION.state.opened = false;
        this.ACCORDION.accordion.classList.remove("js-accordion--active");
      }

      /* ...иначе показываем */
    } else {
      /* если одновременно может быть раскрыт только один элемент, то есть нет атрибута data-type со значением any... */
      if (this.ACCORDION.accordionType !== "any") {
        /*...находим ранее активный элемент и скрываем его */

        if (this.ACCORDION.activeItem && this.ACCORDION.currentClosedItem == false) {
          this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
          this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
          this.ACCORDION.activeItem = "";
          this.ACCORDION.currentClosedItem.closeAccordion(); // Закрываем не текущий, а ранее активный элемент аккордеона
        }
      }

      /* показываем элемент, по которому был осуществлён клик */
      if (this.ACCORDION.currentOpenedItem == false) {
        this.ACCORDION.currentOpenedItem = this;
        this.openAccordion();
        if (!this.ACCORDION.state) {
          this.ACCORDION.state.opened = true;
          this.ACCORDION.accordion.classList.add("js-accordion--active");
        }
        if (this.ACCORDION.activeItems.length === this.ACCORDION.allItems.length && !this.ACCORDION.state.openedAll) {
          this.ACCORDION.state.openedAll = true;
        } else if (this.ACCORDION.activeItems.length < this.ACCORDION.allItems.length && this.ACCORDION.state.openedAll) {
          this.ACCORDION.state.openedAll = false;
        }
      }
      this.ACCORDION.accordion.classList.add("js-accordion--active");
    }

    /* если есть атрибут data-once, то клик по элементу аккордеона отлавливается только один раз, то есть его нельзя закрыть */
    if (this.once) {
      this.accordionHeadElement.removeEventListener("click", this.onAccordionClick.bind(this));
    }
  };
  AccordionItem.prototype.closeAccordion = function () {
    var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var ACCORDION_ITEM = this;
    var closedText = this.accordionItemElement.getAttribute("data-closed-text"); // todo: Проверить работу
    var height = this.accordionContentElement.clientHeight + "px";
    this.accordionItemElement.classList.add("js-accordion-item--close-ready");
    this.accordionContentElement.style.height = height;
    if (closedText) {
      this.accordionText.textContent = closedText; // TODO: Проверить работу
    }
    if (getComputedStyle(this.accordionContentElement).transition && !now) {
      // TODO: доработать, так как отрицательно влияет на рендеринг
      this.accordionContentElement.addEventListener("transitionend", this.closeListener);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ACCORDION_ITEM.accordionContentElement.style.height = "0px";
        });
      });
    } else {
      ACCORDION_ITEM.accordionContentElement.style.height = "0px";
      this.onCloseTransitionEnd();
    }
  };
  AccordionItem.prototype.onCloseTransitionEnd = function () {
    // стили находятся в файле /assets/styles/page.styl
    this.accordionItemElement.classList.remove("js-accordion-item--active");
    this.accordionItemElement.classList.remove("js-accordion-item--close-ready");
    this.accordionContentElement.removeEventListener("transitionend", this.closeListener);

    // if (this.ACCORDION.accordionType !== "any") {
    this.ACCORDION.currentClosedItem = "";
    // }

    if (this.ACCORDION.heightUpdateFlag) {
      window.gsap && itsoftApp.libraries.scrollTrigger.loaded && ScrollTrigger.refresh();
    }
    this.state.opened = false;
  };
  AccordionItem.prototype.openAccordion = function () {
    var ACCORDION = this;
    var openedText = this.accordionItemElement.getAttribute("data-opened-text"); //todo: проверить

    /* если есть атрибут со значением, заменяем название элемента аакордеона во время открытия */
    if (openedText) {
      this.accordionText.textContent = openedText; // todo: проверить
    }
    this.accordionItemElement.classList.add("js-accordion-item--open-ready");
    this.accordionContentElement.style.height = "auto";
    var height = this.accordionContentElement.clientHeight + "px";
    this.accordionContentElement.style.height = "0px";
    if (getComputedStyle(this.accordionContentElement).transition) {
      // TODO: доработать, так как отрицательно влияет на рендеринг
      this.accordionContentElement.addEventListener("transitionend", this.openListener);

      /* чтобы была анимация открытия */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ACCORDION.accordionContentElement.style.height = height;
        });
      });
    } else {
      ACCORDION.accordionContentElement.style.height = height;
      this.onOpenTransitionEnd();
    }
  };
  AccordionItem.prototype.onOpenTransitionEnd = function () {
    // стили находятся в файле /assets/styles/page.styl
    /* если одноврменно может быть показан только один элемент аккордеона, то добавляем другую анимацию,
    //     чтобы раскрытый аккордеон не ушел за пределы экрана из-за прокрутки страницы */
    this.accordionItemElement.classList.remove("js-accordion-item--open-ready");
    this.accordionItemElement.classList.add("js-accordion-item--active");
    this.accordionContentElement.removeEventListener("transitionend", this.openListener);

    // if (this.ACCORDION.accordionType !== "any") {
    this.ACCORDION.activeItem = this;
    this.ACCORDION.activeItems.push(this);
    this.ACCORDION.currentOpenedItem = "";
    // }

    if (this.ACCORDION.heightUpdateFlag) {
      window.gsap && itsoftApp.libraries.scrollTrigger.loaded && ScrollTrigger.refresh();
    }
    this.state.opened = true;
  };
  var Accordion = function Accordion(accordion) {
    this.state = {
      opened: false,
      openedAll: false
    }, this.accordion = accordion;
    this.accordionType = accordion.getAttribute("data-type");
    this.leastOne = accordion.hasAttribute("data-least-one");
    this.accordionItemElements = accordion.querySelectorAll(".js-accordion-item");
    this.accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");
    this.allItems = [];
    this.activeItems = [];
    this.activeItem = "";
    this.activeAccordionContent = "";
    this.currentItem = "";
    this.currentOpenedItem = "";
    this.currentClosedItem = "";
    this.currentOpenedContent = "";
    this.currentClosedContent = "";
    this.heightUpdateFlag = accordion.hasAttribute("data-height-update");
    this.init();
  };
  Accordion.prototype.init = function () {
    /* Добавляет каждому элементу аккордеона обработчик события клика */
    var ACCORDION = this;
    Array.from(ACCORDION.accordionItemElements).forEach(function (el) {
      var accordionItem = new AccordionItem(el, ACCORDION);
      ACCORDION.allItems.push(accordionItem);
      if (accordionItem.state.opened) {
        ACCORDION.activeItems.push(accordionItem);

        // if (ACCORDION.accordionType !== "any") { // todo: Обязательно протестировать этот момент
        ACCORDION.activeItem = accordionItem;
        // }
      }
    });
    var debouncedUpdate = itsoftApp.utils.debouncer(function () {
      if (ACCORDION.accordion.classList.contains("js-accordion--active")) {
        Array.prototype.forEach.call(ACCORDION.activeItems, function (el) {
          var content = el.accordionContentElement;
          content.style.height = "auto";
          var height = content.clientHeight + "px";
          content.style.height = height;
        });
      }
    }, 500);
    itsoftApp.modules.windowResize.addEvent(function () {
      debouncedUpdate();
    });
  };
  module.callback = Accordion;
});
"use strict";

/**
 * Свечение под курсором в блоке "Где купить".
 *
 * Раньше это был один размытый блок под всей сеткой логотипов: он был виден
 * сквозь прозрачные плитки, а всё лишнее закрывали белые тени вокруг них.
 * В неполном последнем ряду закрывать было нечем — свечение вылезало
 * в пустые ячейки по бокам списка.
 *
 * Теперь свечение — это фон-градиент внутри каждой плитки (.buying__glow).
 * Модуль задаёт всем плиткам одну и ту же точку центра (в координатах
 * .buying__col), поэтому визуально блик остаётся общим и непрерывным,
 * но нарисоваться вне плитки он не может в принципе: пустых ячеек
 * с элементом .buying__glow просто нет.
 *
 * NOTE: только то, что есть в Safari 12+ — radial-gradient,
 * background-position/-size, requestAnimationFrame.
 */
itsoftApp.createModule("buyingGlow", ["pageLoad", "windowResize"], function () {
  var module = this;
  var DESKTOP_MIN_WIDTH = 1024; // синхронизировано с брейкпоинтом desktop в стилях
  var SHOW_CLASS = "_show";
  var BuyingGlow = function BuyingGlow(container) {
    this.container = container;
    this.glows = container.querySelectorAll(".js-buying-glow");
    this.offsets = []; // смещения плиток относительно контейнера
    this.radius = 0; // половина размера градиента (задан в CSS)
    this.measured = false;
    this.frame = null;
    this.pointerX = 0;
    this.pointerY = 0;
    if (this.glows.length) {
      this.init();
    }
  };
  BuyingGlow.prototype.isDesktop = function () {
    return itsoftApp.calculations.viewWidth >= DESKTOP_MIN_WIDTH;
  };

  /**
   * Замер геометрии: смещения плиток и размер градиента.
   * Делается один раз на каждый размер окна, а не на каждое движение мыши.
   */
  BuyingGlow.prototype.measure = function () {
    var THIS = this;
    var rect = THIS.container.getBoundingClientRect();
    var size, glowRect, i, len;
    THIS.offsets = [];
    for (i = 0, len = THIS.glows.length; i < len; i++) {
      glowRect = THIS.glows[i].getBoundingClientRect();
      THIS.offsets.push([glowRect.left - rect.left, glowRect.top - rect.top]);
    }

    // размер блика берём из CSS, чтобы не дублировать значение в JS
    // (Safari может вернуть его в виде "calc(600px)" — достаём число регуляркой)
    size = /(-?[\d.]+)px/.exec(getComputedStyle(THIS.glows[0]).backgroundSize);
    THIS.radius = size ? parseFloat(size[1]) / 2 : 0;
    THIS.measured = THIS.radius > 0;
    return THIS.measured;
  };

  /**
   * Ставит центр блика в точку курсора — одинаково для всех плиток.
   */
  BuyingGlow.prototype.render = function () {
    var THIS = this;
    var offset, i, len;
    THIS.frame = null;
    for (i = 0, len = THIS.glows.length; i < len; i++) {
      offset = THIS.offsets[i];
      THIS.glows[i].style.backgroundPosition = Math.round(THIS.pointerX - offset[0] - THIS.radius) + "px " + Math.round(THIS.pointerY - offset[1] - THIS.radius) + "px";
    }
  };
  BuyingGlow.prototype.setPointer = function (e) {
    var THIS = this;
    var rect = THIS.container.getBoundingClientRect();
    THIS.pointerX = e.clientX - rect.left;
    THIS.pointerY = e.clientY - rect.top;
  };
  BuyingGlow.prototype.onEnter = function (e) {
    var THIS = this;
    if (!THIS.isDesktop()) {
      return;
    }
    if (!THIS.measured && !THIS.measure()) {
      return;
    }
    THIS.setPointer(e);
    THIS.render();
    THIS.container.classList.add(SHOW_CLASS);
  };
  BuyingGlow.prototype.onMove = function (e) {
    var THIS = this;
    if (!THIS.measured || !THIS.isDesktop()) {
      return;
    }
    THIS.setPointer(e);
    if (THIS.frame === null) {
      THIS.frame = window.requestAnimationFrame(THIS.render.bind(THIS));
    }
  };
  BuyingGlow.prototype.onLeave = function () {
    var THIS = this;
    THIS.container.classList.remove(SHOW_CLASS);
    if (THIS.frame !== null) {
      window.cancelAnimationFrame(THIS.frame);
      THIS.frame = null;
    }
  };
  BuyingGlow.prototype.onResize = function () {
    var THIS = this;

    // геометрия поменялась — пересчитаем при следующем наведении
    THIS.measured = false;
    if (!THIS.isDesktop()) {
      THIS.onLeave();
    }
  };
  BuyingGlow.prototype.init = function () {
    var THIS = this;
    THIS.container.addEventListener("mouseenter", THIS.onEnter.bind(THIS));
    THIS.container.addEventListener("mousemove", THIS.onMove.bind(THIS));
    THIS.container.addEventListener("mouseleave", THIS.onLeave.bind(THIS));
    itsoftApp.modules.windowResize.addEvent(THIS.onResize.bind(THIS), "buyingGlow");
  };
  var containers = document.querySelectorAll(".js-buying-glow-container");
  var i, len;
  if (containers.length) {
    if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth) {
      itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth = true;
    }
    if (itsoftApp.calculations.viewWidth === null) {
      itsoftApp.utils.getViewportSize();
    }
    for (i = 0, len = containers.length; i < len; i++) {
      new BuyingGlow(containers[i]);
    }
  }
  module.callback = BuyingGlow;
});
"use strict";

itsoftApp.createModule("cookie", function () {
  var module = this;
  var Cookie = function Cookie() {
    this.MAX_DATE = 2000000000;
    this.SESSION_DATE = 86400;
  };
  Cookie.prototype.setCookie = function (element, date) {
    var dAttrSave = element.getAttribute("data-save");
    var dAttrExpires = element.getAttribute("data-expires");
    if (date) {
      if (date == 'day') {
        document.cookie = dAttrSave + "=yes; path=/; max-age=" + this.SESSION_DATE;
      } else {
        document.cookie = dAttrSave + "=yes; path=/; max-age=" + date;
      }
    } else if (dAttrExpires) {
      if (dAttrExpires === "max") {
        dAttrExpires = this.MAX_DATE;
      }
      document.cookie = dAttrSave + "=yes; path=/; max-age=" + dAttrExpires;
    } else {
      document.cookie = dAttrSave + "=yes; path=/"; /* одна сессия */
    }
  };
  Cookie.prototype.getCookie = function (element) {
    var dAttrSave = element.getAttribute("data-save");
    var matches = document.cookie.match(new RegExp("(?:^|; )" + dAttrSave.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };
  Cookie.prototype.deleteCookie = function (element) {
    this.setCookie(element, {
      "max-age": -1
    }, "");
  };
  var cookieItem = new Cookie();
  module.setCookie = cookieItem.setCookie;
  module.getCookie = cookieItem.getCookie;
  module.deleteCookie = cookieItem.deleteCookie;
});
"use strict";

/**
 * Кнопки в левом нижнем углу экрана
 * (только в режиме dev)
 *
 * NOTE: Код подключается с доп. командой DEBUG && -
 * это значит, что при минификации скриптов
 * данный модуль будет целиком вырезан, и можно не париться насчёт лишних килобайтов.
 */
DEBUG && itsoftApp.createModule("devBtns", function () {
  var module = this;
  var DevBtns = function DevBtns() {
    this.links = document.querySelectorAll("link");
    this.toggled = false;
    this.init();
  };

  /**
   * Отображение без стилей
   * (полезно для проверки чистой разметки, заголовков, секций и т. п.)
   */
  DevBtns.prototype.checkStyles = function () {
    var link, i, media;
    if (!this.toggled) {
      for (i = this.links.length - 1; i >= 0; i--) {
        link = this.links[i];
        media = link.getAttribute("media");
        if (!media) {
          continue;
        }
        link.setAttribute("data-media", media);
        link.setAttribute("media", "none");
      }
      this.toggled = true;
    } else {
      for (i = this.links.length - 1; i >= 0; i--) {
        link = this.links[i];
        media = link.getAttribute("data-media");
        if (!media) {
          continue;
        }
        link.setAttribute("media", media);
        link.removeAttribute("data-media");
      }
      this.toggled = false;
    }
  };
  DevBtns.prototype.setStyles = function () {
    var DEVBTNS = this;
    var btn = document.querySelector(".js-toggle-styles");
    if (!btn) {
      return false;
    }
    this.toggled = false;
    btn.addEventListener("click", DEVBTNS.checkStyles.bind(DEVBTNS), false);
  };

  /**
   * Отображение без изображений,
   * но так, чтобы был виден текст атрибута alt.
   */
  DevBtns.prototype.checkImages = function () {
    var dAttrSrcOri = "data-src-ori";
    var attrSrc = "src";
    var dAttrSrcsetOri = "data-srcset-ori";
    var attrSrcset = "srcset";
    var i, img;
    var images = document.querySelectorAll("img, source");

    /* находим все изображения, чтобы можно было у них убрать значение атрибута src или srcset */
    /* тем самым мы можем опредлить, из-за каих картинок скачет страница */

    for (i = images.length - 1; i >= 0; i--) {
      img = images[i];
      if (!this.toggled) {
        if (img.hasAttribute(attrSrc)) {
          img.setAttribute(dAttrSrcOri, img.getAttribute(attrSrc));
          img.removeAttribute(attrSrc);
        }
        if (img.hasAttribute(attrSrcset)) {
          img.setAttribute(dAttrSrcsetOri, img.getAttribute(attrSrcset));
          img.removeAttribute(attrSrcset);
        }
      } else {
        if (img.hasAttribute(dAttrSrcOri)) {
          img.setAttribute(attrSrc, img.getAttribute(dAttrSrcOri));
          img.removeAttribute(dAttrSrcOri);
        }
        if (img.hasAttribute(dAttrSrcsetOri)) {
          img.setAttribute(attrSrcset, img.getAttribute(dAttrSrcsetOri));
          img.removeAttribute(dAttrSrcsetOri);
        }
      }
    }
    this.toggled = !this.toggled;
  };
  DevBtns.prototype.setImages = function () {
    var DEVBTNS = this;
    var btn = document.querySelector(".js-toggle-images");
    if (!btn) {
      return false;
    }
    btn.addEventListener("click", DEVBTNS.checkImages.bind(DEVBTNS), false);
  };
  DevBtns.prototype.setListeners = function () {
    this.setStyles();
    this.setImages();
  };
  DevBtns.prototype.init = function () {
    if (!document.querySelector(".js-toggle-styles") && !document.querySelector(".js-toggle-images")) {
      return false;
    }
    this.setListeners();
  };
  new DevBtns();
  module.callback = DevBtns;
});
"use strict";

itsoftApp.createModule("disclaimer", ["pageLoad", "cookie"], function () {
  var module = this;
  var bodyEnd = document.querySelector(".js-padding-bottom");
  var Disclaimer = function Disclaimer() {
    this.scrollTriggerElement = null;
    this.disclaimerWrapper = document.querySelector(".js-disclaimer-wrapper");
    this.scrollSmootherUsed = false;
    this.disclaimerPosition = null; /* сохраняем сюда элемент, где визуально должен находиться дисклеймер в состоянии static или inactive; пока не используется */
    this.footer = document.querySelector(".page-footer");
    this.disclaimer = document.querySelector(".js-disclaimer"); /* У дисклеймера должен быть такой класс */
    this.state = "static";
    this.gap = 0;
    this.cookies = document.querySelector(".js-cookies");
    this.button = document.querySelector(".disclaimer__close-button"); /* Крестик */
    this.confirm = document.querySelector(".disclaimer__confirm"); /* элемент подтвеждения закрытия */
    this.text = document.querySelector(".disclaimer__text");
    this.disclaimerParts = document.querySelectorAll(".disclaimer__part");
    this.footerCoordY;
    this.sTop;
    this.requiredPercentage = 8;
    if (this.disclaimer) {
      this.init();
      this.onScroll = this.onDocumentScroll.bind(this);
      this.onResize = this.onDocumentResize.bind(this);
    }
  };
  Disclaimer.prototype.buttonMouseOver = function () {
    var DISCLAIMER = this;
    if (!this.disclaimer.classList.contains("js-hover")) {
      this.disclaimer.classList.add("js-hover");
      if (this.confirm) {
        this.confirm.addEventListener("mouseleave", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
      }
    }
  };
  Disclaimer.prototype.buttonMouseOut = function () {
    var DISCLAIMER = this;
    this.disclaimer.classList.remove("js-hover");
    this.confirm.removeEventListener("mouseleave", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
  };
  Disclaimer.prototype.close = function () {
    var DISCLAIMER = this;
    itsoftApp.modules.cookie.setCookie(DISCLAIMER.disclaimer);
    this.state = "static";
    this.disclaimer.classList.add("js-static");
    this.disclaimer.classList.add("js-inactive");
    if (this.disclaimer.classList.contains("js-hover")) {
      this.disclaimer.classList.remove("js-hover");
    }
    if (this.confirm) {
      this.confirm.style.display = "none";
    }
    if (this.disclaimerWrapper) {
      this.disclaimerWrapper.appendChild(this.disclaimer);
    }
    this.footer.classList.add("js-update");
    if (!DISCLAIMER.scrollSmootherUsed) {
      document.removeEventListener("scroll", DISCLAIMER.onScroll);
    }
    window.removeEventListener("resize", DISCLAIMER.onResize);
    if (DISCLAIMER.cookies) {
      DISCLAIMER.cookies.style.bottom = 0;
    }
    if (bodyEnd) {
      bodyEnd.style.paddingBottom = 0;
    }
  };
  Disclaimer.prototype.checkButton = function () {
    var DISCLAIMER = this;
    if (DISCLAIMER.button) {
      DISCLAIMER.button.addEventListener("mouseover", DISCLAIMER.buttonMouseOver.bind(DISCLAIMER));
      DISCLAIMER.button.addEventListener("click", function (evt) {
        evt.preventDefault();
        this.close = DISCLAIMER.close();
      });
    }
  };
  Disclaimer.prototype.checkConfirm = function () {
    var DISCLAIMER = this;
    if (DISCLAIMER.confirm) {
      DISCLAIMER.confirm.addEventListener("click", function (evt) {
        evt.preventDefault();
        this.close = DISCLAIMER.close();
      });
    }
  };
  Disclaimer.prototype.defineCoordY = function () {
    var DISCLAIMER = this;
    DISCLAIMER.footerCoordY = DISCLAIMER.footer.getBoundingClientRect().top + pageYOffset;
  };

  /* Вычисляем координаты. Если мы прокрутили страницу до подвала, делаем дисклеймер статичным */
  Disclaimer.prototype.checkElementCoords = function () {
    var DISCLAIMER = this;
    var reVerified = false;
    this.sTop = pageYOffset;
    if (this.sTop > 200 && !reVerified) {
      // изредка неправильно определяет координаты сразу после полной загрузки страницы, поэтом нужна одна доп. проверка
      reVerified = true;
      DISCLAIMER.defineCoordY();
    }
    if (this.sTop + document.documentElement.clientHeight > this.footerCoordY) {
      if (this.disclaimerWrapper) {
        this.disclaimerWrapper.appendChild(this.disclaimer);
        DISCLAIMER.defineCoordY();
      }
      if (DISCLAIMER.state != "inactive") {
        DISCLAIMER.state = "inactive";

        // if (bodyEnd) {
        //     bodyEnd.style.paddingBottom = 0;
        // }
      }
      if (this.button) {
        this.button.classList.add("js-close-hide");
      }
      if (this.confirm) {
        this.confirm.style.display = "none";
      }
      this.disclaimer.classList.add("js-inactive");
      if (DISCLAIMER.cookies) {
        DISCLAIMER.cookies.style.bottom = 0;
      }
    } else if (!this.disclaimer.classList.contains("js-static")) {
      if (this.disclaimerWrapper) {
        document.body.appendChild(this.disclaimer);
        DISCLAIMER.defineCoordY();
      }
      if (DISCLAIMER.state != "active") {
        DISCLAIMER.state = "active";

        // if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
        //     itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
        //     itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
        // }

        // if (bodyEnd) {
        //     bodyEnd.style.paddingBottom = itsoftApp.calculations.disclaimerHeight + "px";
        // }
      }
      if (this.button) {
        this.button.classList.remove("js-close-hide");
      }
      if (this.confirm) {
        this.confirm.style.display = "";
      }
      this.disclaimer.classList.remove("js-inactive");
      if (DISCLAIMER.cookies) {
        DISCLAIMER.height = itsoftApp.calculations.disclaimerHeight;
        DISCLAIMER.disclaimer.style.bottom = DISCLAIMER.cookies.clientHeight + DISCLAIMER.gap + "px";
      }
    }
  };
  Disclaimer.prototype.onDocumentScroll = function () {
    var DISCLAIMER = this;
    DISCLAIMER.checkElementCoords();
  };
  Disclaimer.prototype.onDocumentResize = function () {
    /* Обновляем координаты при ресайзе */
    var DISCLAIMER = this;
    DISCLAIMER.calcFontSize();
    DISCLAIMER.defineCoordY();
    if (DISCLAIMER.cookies) {
      /* todo: доработать, достать из itsoftApp.calculations.disclaimerHeight */
      DISCLAIMER.height = DISCLAIMER.disclaimer.getBoundingClientRect().height;
      DISCLAIMER.disclaimer.style.bottom = DISCLAIMER.cookies.clientHeight + DISCLAIMER.gap + "px";
    }
    DISCLAIMER.checkElementCoords();
  };
  Disclaimer.prototype.init = function () {
    var DISCLAIMER = this;
    if (DISCLAIMER.disclaimer.hasAttribute("data-always-active-on-mobile")) {
      DISCLAIMER.alwaysActiveOnMobile = true;
    }
    if (DISCLAIMER.disclaimer) {
      /* Инициализируем модуль после полной загрузки страницы, только если на странице есть дисклеймер */
      itsoftApp.modules.pageLoad.addEvent(function () {
        if (DISCLAIMER.disclaimerWrapper) {
          DISCLAIMER.disclaimerPosition = DISCLAIMER.disclaimerWrapper;
        } else {
          DISCLAIMER.disclaimerPosition = DISCLAIMER.disclaimer;
        }
        DISCLAIMER.calcFontSize();
        DISCLAIMER.dAttrSave = DISCLAIMER.disclaimer.getAttribute("data-save");
        if (!DISCLAIMER.dAttrSave || DISCLAIMER.dAttrSave && !itsoftApp.modules.cookie.getCookie(DISCLAIMER.disclaimer)) {
          DISCLAIMER.defineCoordY();
          itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
          itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
          DISCLAIMER.checkElementCoords();
        } else {
          DISCLAIMER.state = "static";
          if (DISCLAIMER.disclaimerWrapper) {
            DISCLAIMER.disclaimerWrapper.appendChild(DISCLAIMER.disclaimer);
            DISCLAIMER.defineCoordY();
          }
          return;
        }
        if (DISCLAIMER.sTop + document.documentElement.clientHeight > DISCLAIMER.footerCoordY) {
          DISCLAIMER.state = "inactive";
        } else {
          DISCLAIMER.state = "active";
        }
        if (bodyEnd && DISCLAIMER.alwaysActiveOnMobile) {
          if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
            itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
            itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
          }
          bodyEnd.style.paddingBottom = itsoftApp.calculations.disclaimerHeight + "px";
        }
        if (DISCLAIMER.disclaimerWrapper) {
          DISCLAIMER.height = DISCLAIMER.disclaimer.getBoundingClientRect().height;
          DISCLAIMER.disclaimerWrapper.style.height = DISCLAIMER.height + "px";
        }
        if (DISCLAIMER.cookies && DISCLAIMER.state == "active") {
          DISCLAIMER.disclaimer.style.bottom = DISCLAIMER.cookies.clientHeight + DISCLAIMER.gap + "px";
        }
        document.addEventListener("scroll", DISCLAIMER.onScroll, {
          passive: true
        });
        /* todo: доработать, достать из itsoftApp.calculations.disclaimerHeight */
        window.addEventListener("resize", DISCLAIMER.onResize);
        DISCLAIMER.onDocumentResize();
      });
      DISCLAIMER.checkButton();
      DISCLAIMER.checkConfirm();
    }
  };
  Disclaimer.prototype.getWordsSquare = function () {
    var square = 0;
    Array.prototype.forEach.call(this.disclaimerParts, function (word) {
      var blockW = word.clientWidth;
      var blockH = word.clientHeight;
      var currentSquare = blockW * blockH;
      square += currentSquare;
    });
    return square;
  };
  Disclaimer.prototype.getWindowSquare = function () {
    var bodyWidth = itsoftApp.utils.getViewportSize();
    var bodyHeight = itsoftApp.utils.getViewportHeight();
    return bodyWidth * bodyHeight;
  };
  Disclaimer.prototype.getFinalValue = function (square) {
    var percent = square * 100 / this.getWindowSquare();
    return percent > this.requiredPercentage;
  };
  Disclaimer.prototype.setFontSize = function (size) {
    this.text.style.fontSize = size + "px";
    this.text.setAttribute("data-font-size", size);
  };
  Disclaimer.prototype.getFontSize = function () {
    return parseInt(this.text.getAttribute("data-font-size"), 10) || 8;
  };
  Disclaimer.prototype.calcFontSize = function () {
    var DISCLAIMER = this;
    var counter = 0;
    if (window.innerWidth > 1023) {
      DISCLAIMER.setFontSize(32);
    } else {
      DISCLAIMER.setFontSize(22);
    }
    while (this.getFinalValue(this.getWordsSquare(), this.requiredPercentage) === false) {
      if (counter++ > 100) {
        break;
      }
      ;
      if (window.innerWidth > 1023 && DISCLAIMER.text.clientHeight > DISCLAIMER.disclaimerParts[0].clientHeight) {
        DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() - 3);
        break;
      }
      if (window.innerWidth <= 1023 && DISCLAIMER.text.clientHeight > DISCLAIMER.disclaimerParts[0].clientHeight * 2) {
        DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() - 2);
        break;
      }
      DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() + 2);
    }
    var fontSize = this.getFontSize();
    this.text.style.fontSize = fontSize + "px";
  };
  window.DISCLAIMER = new Disclaimer();
  module.callback = Disclaimer;
});
"use strict";

itsoftApp.createModule("focusVisible", function () {
  /* Эмулирем на JS псевдокласс focus-visible, так как некоторые браузеры его не поддерживают */
  /* При клике с помощью мышки или пальца не будут срабатывать стили для :focus */
  var module = this;
  var FocusVisible = function FocusVisible() {
    this.path = "/assets/scripts/focus-visible/focus-visible.min.js";
    this.init();
  };
  FocusVisible.prototype.init = function () {
    itsoftApp.loadScript(this.path);
  };
  new FocusVisible();
  module.callback = FocusVisible;
});
"use strict";

itsoftApp.createModule("headerFix", ["pageLoad", "windowScroll", "windowResize"], function () {
  var module = this;
  var Header = function Header() {
    this.header = document.querySelector(".page-header");
    this.pageWrapper = document.querySelector(".l-wrapper");
    this.headerFixed = false;
    this.paddingElems = document.querySelectorAll(".js-padding");
    this.headerHeight;
    this.borderMenuLinks = document.querySelector('.js-border-link');
    this.init();
  };
  Header.prototype.setPagePadding = function () {
    var HEADER = this;
    // учитывается, что высота шапки может поменяться по мере скролла, поэтому нужно измерить высоту шапки в нормальном состоянии

    if (HEADER.paddingElems) {
      Array.prototype.forEach.call(HEADER.paddingElems, function (el) {
        el.style.paddingTop = itsoftApp.calculations.headerStaticHeight + "px";
      });
    } else {
      HEADER.pageWrapper.style.paddingTop = itsoftApp.calculations.headerStaticHeight + "px";
    }
  };
  Header.prototype.updHeaderHeightAndPadding = function () {
    var HEADER = this;
    if (HEADER.header) {
      HEADER.header.classList.remove("js-fixed");
      if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight) {
        itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight = true;
        itsoftApp.calculations.headerHeight = itsoftApp.utils.getHeaderHeight();
      }
      HEADER.headerHeight = itsoftApp.calculations.headerHeight;
      if (pageYOffset !== 0) {
        HEADER.header.classList.add("js-fixed");
      }
      HEADER.setPagePadding();
    }
  };
  Header.prototype.modifyHeader = function () {
    var HEADER = this;
    if (pageYOffset > 0 && !HEADER.headerFixed) {
      HEADER.header.classList.add("js-fixed");
      HEADER.headerFixed = true;
      if (HEADER.borderMenuLinks && HEADER.borderMenuLinks.classList.contains('_active')) ;
      {
        HEADER.borderMenuLinks.classList.remove('_active');
      }
    } else if (pageYOffset === 0) {
      HEADER.header.classList.remove("js-fixed");
      HEADER.headerFixed = false;
      if (HEADER.borderMenuLinks && HEADER.borderMenuLinks.classList.contains('_active')) ;
      {
        HEADER.borderMenuLinks.classList.remove('_active');
      }
    }
  };
  Header.prototype.init = function () {
    var HEADER = this;
    if (HEADER.header) {
      // itsoftApp.modules.pageLoad.addEvent(function () {
      HEADER.headerHeight = itsoftApp.utils.getHeaderHeight();
      if (pageYOffset > 0 && !HEADER.headerFixed) {
        itsoftApp.utils.getHeaderStaticHeight();
        HEADER.header.classList.add("js-fixed");
        HEADER.headerFixed = true;
        itsoftApp.utils.getHeaderFixedHeight();
      } else if (pageYOffset === 0) {
        itsoftApp.utils.getHeaderStaticHeight();
        itsoftApp.utils.getHeaderFixedHeight(); // TODO: надо оптимизировать лишнее вычисление
        HEADER.header.classList.remove("js-fixed");
        HEADER.headerFixed = false;
      }
      itsoftApp.modules.windowResize.addEvent(HEADER.updHeaderHeightAndPadding.bind(HEADER));
      itsoftApp.modules.windowScroll.addEvent(HEADER.modifyHeader.bind(HEADER));
      HEADER.modifyHeader();
      HEADER.setPagePadding();
      if (HEADER.header.hasAttribute("data-default")) {
        HEADER.header.removeAttribute("data-default");
      }
      // });
    }
  };
  new Header();
  module.callback = Header;
});
"use strict";

itsoftApp.createModule("help", ["windowScroll"], function () {
  var module = this;
  var Help = function Help() {
    this.container = document.querySelector('.js-anim-help');
    this.video = this.container && this.container.querySelector('.js-anim-help-video');
    this.items = this.container && this.container.querySelectorAll('.js-anim-help-item');
    this.offsetTop = -100;
    this.play = false;
    if (this.container) {
      this.init();
    }
  };
  Help.prototype.init = function () {
    var THIS = this;
    THIS.onScroll();
    itsoftApp.modules.windowScroll.addEvent(THIS.onScroll.bind(THIS));
  };
  Help.prototype.onScroll = function () {
    var THIS = this;
    if (window.innerWidth > 767 && THIS.isBlockInWindow(THIS.container) && !THIS.play) {
      THIS.startAnim();
    }
  };
  Help.prototype.startAnim = function () {
    var THIS = this;
    THIS.play = true;
    THIS.video.play();
    var curIndex = 1;
    var _loop = function _loop() {
      var element = THIS.items[index];
      var delay = index === THIS.items.length - 1 ? 300 : 300;
      setTimeout(function () {
        element.classList.add('_active');
      }, delay * curIndex);
      curIndex += 1;
    };
    for (var index = THIS.items.length - 1; index >= 0; index--) {
      _loop();
    }
  };
  Help.prototype.isBlockInWindow = function (el) {
    var THIS = this;
    var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      bottom = _el$getBoundingClient.bottom;
    var pointTop = top - THIS.offsetTop;
    var pointBottom = bottom - THIS.offsetTop;
    return pointTop < itsoftApp.calculations.headerHeight && pointBottom > 0;
  };
  new Help();
  module.callback = Help;
});
"use strict";

itsoftApp.createModule("lazyLoading", ["windowResize", "windowScroll", "scrollTo"], function () {
  var module = this;
  window.lazyQueue = [];
  window.lazyInitQueue = function () {
    if (!window.lazyQueue.length) {
      return;
    }
    while (window.lazyQueue.length > 0) {
      // Взять первый элемент массива,
      // и вызвать его. Мы уже знаем, что это функция,
      // поэтому доп. проверка не требуется.
      window.lazyQueue.shift()();
    }
  };
  var checking = false;
  window.lazyFunctions = {
    slider: function slider(element) {
      var sliderSettingsKey = element.getAttribute("data-slider-settings"); // получаем data-атрибут
      var sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

      if (sliderSettingsKey && sliderSettingsObject) {
        new itsoftApp.modules.slidersLibrary.callback(element, sliderSettingsObject);
      } else {
        new itsoftApp.modules.slidersLibrary.callback(element);
      }
    },
    tabs: function tabs(element) {
      new itsoftApp.modules.toggleTabs.callback.init(element);
    },
    scrollTrigger: function scrollTrigger(element) {
      itsoftApp.modules.scrollActions.callback(element, true, false);
    },
    accordion: function accordion(element) {
      new itsoftApp.modules.accordion.callback(element);
    },
    loadItems: function loadItems(element) {
      itsoftApp.modules.loadItems.initLoad(element);
    },
    loadItemsWithFilters: function loadItemsWithFilters(element) {
      itsoftApp.modules.loadItemsWithFilters.initLoad(element);
    },
    uteka: function uteka(element) {
      itsoftApp.modules.utekaInit.callback(element);
      itsoftApp.modules.uteka.callback(element);
    },
    videoPopup: function videoPopup(element) {
      itsoftApp.modules.videoPopup.init(element);
    },
    problem: function problem(element) {
      itsoftApp.modules.problem.init(element);
    }
  };
  function executeLazyFunction(element) {
    var lazyFunctionName = element.getAttribute("data-lazy-function");
    var lazyFunction = window.lazyFunctions[lazyFunctionName];
    if (!lazyFunction) return;
    lazyFunction(element);
  }
  var Lazy = function Lazy() {
    this.path = "/assets/scripts/vanilla-lazyload/lazyload.min.js";
    this.init();
  };
  Lazy.prototype.setSettings = function () {
    window.llEarlier = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".lazyload-earlier",
      class_loaded: "loaded",
      class_entered: "entered",
      thresholds: "-100% 0px"
    });
    window.ll = new LazyLoad({
      // unobserve_entered: true,
      elements_selector: ".lazy, .lazyload",
      class_loaded: "loaded",
      class_entered: "entered",
      cancel_on_exit: true
    });
    window.llCallRequestOptions = {
      unobserve_entered: true,
      class_loaded: "loaded",
      class_entered: "entered"
    };
    window.llCallRequest = new LazyLoad(window.modalOptions);
    window.llCallback = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".lazy-script, .js-script",
      class_entered: "js-script-entered",
      callback_enter: executeLazyFunction
    });
    new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-anim",
      class_entered: "js-anim--show",
      thresholds: "0px 0px"
    });
    new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-anim-custom",
      class_entered: "js-anim-custom--show",
      thresholds: "-30% 0px"
    });
  };
  Lazy.prototype.init = function () {
    itsoftApp.loadScript(this.path, this.setSettings);
  };
  new Lazy();
  module.callback = Lazy;
});
// itsoftApp.createModule("lennis", function () {
//     const module = this;

//     const Lennis = function () {
//         this.path = "/assets/scripts/lennis/lennis.min.js";

//         this.init();
//     };

//     Lennis.prototype.init = function () {
//         const THIS = this;

//         if (THIS.isMobile()) {

//         } else {
//             itsoftApp.loadScript(THIS.path, THIS.setSettings);
//         }

//     };

//     Lennis.prototype.setSettings = function () {
//         // const lennis = new Lenis({
//         //     autoRaf: true,
//         // });

//         const lennis = new Lenis({
//             lerp: 0.08, 
//             wheelMultiplier: 1.2, 
//         });

//         function raf(time) {
//             lennis.raf(time);
//             requestAnimationFrame(raf);
//         }
//         requestAnimationFrame(raf);

//         window.lennis = lennis;

//         const debouncedUpdate = itsoftApp.utils.debouncer(function () {
//             window.lennis.resize();
//         }, 300);

//         const resizeObserver = new ResizeObserver((e) => {
//             debouncedUpdate();

//         });

//         resizeObserver.observe(document.querySelector('.l-wrapper'));
//     };

//     Lennis.prototype.isMobile = function () {
//         return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
//     }

//     new Lennis();
//     module.callback = Lennis;
// });
"use strict";
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
itsoftApp.createModule("linkOtherPage", function () {
  var module = this;
  var LinkOtherPage = function LinkOtherPage() {
    this.header = document.querySelector(".page-header");
    this.selectors = document.querySelectorAll('.js-link-other-page');
    this.time = 1000;
    if (this.selectors.length > 0) {
      this.init();
    }
  };
  LinkOtherPage.prototype.init = function () {
    var THIS = this;
    THIS.bindMethods();
    THIS.addListeners();
    window.addEventListener('pageshow', function (event) {
      if (event.persisted || window.performance && window.performance.navigation.type === 2) {
        var img = document.querySelector('.help-preview');
        var content = document.querySelector('.l-content');
        THIS.header.classList.add('js-fixed');
        document.body.style.overflow = "";
        THIS.setPadding("");
        if (img) {
          img.remove();
        }
        content.classList.remove('_hide');
      }
    });
  };
  LinkOtherPage.prototype.bindMethods = function () {
    var THIS = this;
    THIS.clickHandler = THIS.clickHandler.bind(THIS);
  };
  LinkOtherPage.prototype.addListeners = function () {
    var THIS = this;
    var _iterator = _createForOfIteratorHelper(THIS.selectors),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;
        el.addEventListener('click', THIS.clickHandler);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  LinkOtherPage.prototype.clickHandler = function (e) {
    var THIS = this;
    e.preventDefault();
    var target = e.currentTarget;
    THIS.startAnim(target);
  };
  LinkOtherPage.prototype.startAnim = function (target) {
    var THIS = this;
    var curImg = target.querySelector('.card-help__img');
    var rect = curImg.getBoundingClientRect();
    var imgBox = document.createElement('DIV');
    imgBox.classList.add('help-preview');
    imgBox.style.top = rect.top + 'px';
    imgBox.style.left = rect.left + 'px';
    imgBox.style.width = curImg.clientWidth + 'px';
    imgBox.style.height = curImg.clientHeight + 'px';
    var img = document.createElement('IMG');
    img.classList.add('image');
    img.src = curImg.querySelector('img').src;
    imgBox.appendChild(img);
    document.body.appendChild(imgBox);
    THIS.header.classList.remove('js-fixed');
    THIS.setPadding("".concat(THIS.getScrollbarSize(), "px"));
    document.body.style.overflow = "hidden";
    setTimeout(function () {
      var content = document.querySelector('.l-content');
      imgBox.classList.add('_active');
      imgBox.style.width = curImg.clientWidth * 2.35 + 'px';
      imgBox.style.height = curImg.clientHeight * 2.35 + 'px';
      content.classList.add('_hide');
    }, 1);
    setTimeout(function () {
      window.location.href = target.href;
    }, THIS.time);
  };
  LinkOtherPage.prototype.getScrollbarSize = function () {
    return window.innerWidth - document.body.offsetWidth;
  };
  LinkOtherPage.prototype.setPadding = function (property) {
    var header = document.querySelector(".l-header");
    document.body.style.paddingRight = property;
    if (header) {
      header.style.paddingRight = property;
    }
  };

  // new LinkOtherPage();
  module.callback = LinkOtherPage;
});
"use strict";

itsoftApp.createModule("linksHeader", function () {
  var module = this;
  var LinksHeader = function LinksHeader() {
    this.elements = document.querySelectorAll('.main-menu__link');
    this.el = document.querySelector('.js-border-link');
    if (this.elements.length > 0 && this.el) {
      this.init();
    }
  };
  LinksHeader.prototype.init = function () {
    var THIS = this;
    THIS.bindMethods();
    THIS.addListeners();
  };
  LinksHeader.prototype.bindMethods = function () {
    var THIS = this;
    THIS.onMouseEnter = THIS.onMouseEnter.bind(THIS);
    THIS.onMouseLeave = THIS.onMouseLeave.bind(THIS);
  };
  LinksHeader.prototype.addListeners = function () {
    var THIS = this;
    for (var index = 0; index < THIS.elements.length; index++) {
      var el = THIS.elements[index];
      el.addEventListener('mouseenter', THIS.onMouseEnter);
      el.addEventListener('mousemove', THIS.onMouseEnter);
      el.addEventListener('mouseleave', THIS.onMouseLeave);
    }
  };
  LinksHeader.prototype.onMouseEnter = function (e) {
    var THIS = this;
    var target = e.currentTarget;
    var rect = target.getBoundingClientRect();
    var width = rect.width;
    var top = rect.top;
    var left = rect.left;
    THIS.el.style.width = width + 'px';
    THIS.el.style.transform = "translate(".concat(left, "px, ").concat(top, "px)");
    target.classList.add('_active');
    THIS.el.classList.add('_active');
  };
  LinksHeader.prototype.onMouseLeave = function (e) {
    var THIS = this;
    var target = e.currentTarget;
    target.classList.remove('_active');
    THIS.el.classList.remove('_active');
  };
  new LinksHeader();
  module.callback = LinksHeader;
});
"use strict";

/* globals Raven */

/**
 * Отмена действия по умолчанию для ссылок с атрибутом href="#".
 * В нашей заготовки таковыми являются ссылки, для которых предполагается реальный href,
 * но который на вёрстке ещё не известен.
 * Если не отменить для таких ссылок действие по умолчанию,
 * то при клике страница перепрыгнет на самый верх, а в адресной строке появится #.
 *
 * NOTE: Также данный модуль отправляет сообщения в логгер, если подобные ссылки
 * найдены на продакт-сервере (там вместо # должны быть проставлены реальные адреса).
 */
itsoftApp.createModule("linksWithHash", function () {
  var module = this;
  var LinksWithHash = function LinksWithHash() {
    this.links = document.querySelectorAll("a[href='#']");
    this.isLocal = itsoftApp.isLocal;
    this.init();
  };

  /**
   * Простой обрабочик, который отменяет действие по умолчанию
   *
   * @param  {object} e Event
   */
  LinksWithHash.prototype.linksWithHashHandler = function (e) {
    e.preventDefault();
    DEBUG && console.log("[module linksWithHash] default action prevented for link");
  };

  // Привязка функций к событиям
  LinksWithHash.prototype.addListener = function () {
    var LINKSWITHHASH = this;
    for (var i = 0, len = LINKSWITHHASH.links.length, link; i < len; i++) {
      link = LINKSWITHHASH.links[i];
      link.addEventListener("click", LINKSWITHHASH.linksWithHashHandler.bind(LINKSWITHHASH), false);
    }
  };

  // Если на боевом сервере найдены ссылки с атрибутом href="#",
  // то отправляем в логгер сообщение об ошибке,
  // так как там уже должны быть настоящие ссылки вместо заглушек.
  LinksWithHash.prototype.checkRaven = function () {
    if (typeof Raven !== "undefined" && !this.isLocal) {
      var extra = {};

      // Формируем объект, в котором перечислены все найденные ссылки,
      // причём с указанием их html-кода
      // (для того, чтобы можно было определить, какие именно ссылки найдены, точно ли это ошибка или нет)
      Array.prototype.forEach.call(this.links, function (link, index) {
        var html = link.outerHTML;
        extra["link" + (index + 1)] = html;
      });
      Raven.captureMessage("[module linksWithHash] links with href='#' found", {
        level: "warning",
        // one of 'info', 'warning', or 'error'
        extra: extra
      });
    }
  };
  LinksWithHash.prototype.init = function () {
    if (!this.links.length) {
      return false;
    }
    DEBUG && console.log("%c[module linksWithHash] " + this.links.length + " links with href='#' found. is it ok for this page?? maybe you need to replace '#' with normal link? check it.", "color: orange");
    this.addListener();
    this.checkRaven();
  };
  new LinksWithHash();
  module.callback = LinksWithHash;
});
// itsoftApp.createModule("lottie", ["windowScroll"], function () {
//     const module = this;

//     const Lottie = function () {
//         this.path = "/assets/scripts/lottie/lottie.min.js";
//         this.selectors = document.querySelectorAll('.js-anim-lottie');
//         this.offsetTop = 0;
//         this.libLoaded = false;
//         this.canPlay = false

//         if (this.selectors.length > 0) {
//             this.init();
//         }
//     };

//     Lottie.prototype.init = function () {
//         const THIS = this;

//         THIS.onScroll();
//         itsoftApp.modules.windowScroll.addEvent(THIS.onScroll.bind(THIS));
//     };

//     Lottie.prototype.onScroll = function () {
//         const THIS = this;

//         for (let index = 0; index < THIS.selectors.length; index++) {
//             const el = THIS.selectors[index];
//             if (el.classList.contains('js-anim-lottie--play-now')) {
//                 if (!THIS.libLoaded) {
//                     THIS.loadAndPlay(el);
//                 }
//             } else if (THIS.isBlockInWindow(el)) {
//                 if (!THIS.libLoaded) {
//                     THIS.loadAndPlay(el);
//                 } else {
//                     THIS.play(el);
//                 }
//             }
//         }
//     }

//     Lottie.prototype.loadAndPlay = function (el) {
//         const THIS = this;
//         THIS.libLoaded = true;
//         itsoftApp.loadScript(THIS.path, function () {
//             THIS.canPlay = true;
//             THIS.play(el);
//         });
//     }

//     Lottie.prototype.play = function (el) {
//         const THIS = this;

//         if (THIS.canPlay && !el.classList.contains('_play')) {
//             el.classList.add('_play');

//             lottie.loadAnimation({
//                 container: el,
//                 renderer: 'svg',
//                 loop: true,
//                 autoplay: true,
//                 path: el.dataset.src
//             });
//         }
//     }

//     Lottie.prototype.isBlockInWindow = function (el) {
//         const THIS = this;

//         const { top, bottom } = el.getBoundingClientRect();
//         // const pointTop = top - THIS.offsetTop;
//         const pointBottom = bottom - THIS.offsetTop;

//         return pointBottom < window.innerHeight;
//     }

//     new Lottie();
//     module.callback = Lottie;
// });
"use strict";
"use strict";

/**
 * Мобильное меню
 *
 * NOTE: Модуль можно удалить, если на сайте предусмотрено
 * принципиально иное меню для мобильных устройств.
 */
itsoftApp.createModule("mobMenu", ["windowScroll", "windowResize"], function () {
  var module = this;
  var MobMenu = function MobMenu() {
    this.parentClass = "js-mobmenu";
    this.parent = document.querySelector("." + this.parentClass);
    this.toggleBtns = document.querySelector(".js-mobmenu-toggle");
    this.openedClass = "is-opened";
    this.activeClass = "is-active";
    this.opened = false;
    this.$body = itsoftApp.commonVars.$body;
    this.expandedBlocks = document.querySelector(".js-mobmenu-expand");
    this.fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
    this.getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
    this.menuLinks = document.querySelectorAll(".js-link");
    this.point = 1023;
    if (!this.toggleBtns > 0) {
      return;
    }
    this.init();
  };
  MobMenu.prototype.openMenu = function () {
    if (this.opened) {
      return;
    }
    this.opened = true;
    if (this.fixedPageElems) {
      var scrollbarWidth = this.getScrollbarWidth();
      DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
      Array.prototype.forEach.call(this.fixedPageElems, function (el) {
        el.style.paddingRight = scrollbarWidth + "px";
      });
    }
    this.toggleBtns.classList.add(this.activeClass);
    this.parent.classList.add(this.openedClass);
    document.documentElement.style.overflow = "hidden"; // NOTE: Отменил прокрутку
    document.documentElement.style.touchAction = "none";
    DEBUG && console.log("[module mobMenu] menu opened");
  };
  MobMenu.prototype.closeMenu = function () {
    if (!this.opened) {
      return;
    }
    this.opened = false;
    if (this.fixedPageElems) {
      Array.prototype.forEach.call(this.fixedPageElems, function (el) {
        el.style.paddingRight = "0";
      });
    }
    document.documentElement.style.overflow = "visible"; // NOTE: Вернул прокрутку
    document.documentElement.style.touchAction = "";
    this.toggleBtns.classList.remove(this.activeClass);
    this.parent.classList.remove(this.openedClass);
    DEBUG && console.log("[module mobMenu] menu closed");
  };
  MobMenu.prototype.toggleBtnClick = function (evt) {
    var MOBMENU = this;
    evt.preventDefault();
    if (this.opened) {
      MOBMENU.closeMenu();
    } else {
      MOBMENU.openMenu();
    }
  };

  /**
   * Обработчик события пролистывания страницы.
   * Мы будем скрывать меню, если пользователь начал листать страницу вниз.
   *
   * @param  {number} y Текущее значение прокрутки страницы
   */
  MobMenu.prototype.scrollController = function (y) {
    var MOBMENU = this;
    if (!this.opened) {
      return;
    }
    // Значение уже придёт нам из модуля itsoftApp.modules.windowScroll,
    // но на всякий случай пропишем fallback.
    y = typeof y === "number" ? y : document.body.scrollTop || document.documentElement.scrollTop;
    var menuHeight = this.parent.offsetHeight + this.expandedBlocks.offsetHeight;

    // if (y > menuHeight + 20) {
    if (y + menuHeight > menuHeight + menuHeight / 3) {
      MOBMENU.closeMenu();
    }
  };

  /**
   * Обработчик события ресайза страницы.
   * Мы будем скрывать меню, если ширина страницы больше, чем ширина страницы при показе бургера
   */
  MobMenu.prototype.resizeController = function (evt) {
    var MOBMENU = this;
    if (window.innerWidth > MOBMENU.point && MOBMENU.opened) {
      MOBMENU.closeMenu();
    }
  };

  /**
   * Как и в случае со всплывашками на сайте,
   * для меню, если мы видим оставшуюся часть страницы, и кликаем по затемнённой области,
   * то пользователь интуитивно ожидает, что меню закроется.
   * Данный обработчик как раз для этого.
   *
   * @param  {object} e Event
   */
  MobMenu.prototype.bodyClick = function (e) {
    var MOBMENU = this;
    if (!this.opened) {
      return;
    }
    var target = e.target;
    var hasParent = target.closest("." + this.parentClass);

    // Закрываем меню, только если клик произошёл
    // по элементу вне пределов родительского блока
    // (по сути - клик по любой точке экрана, кроме меню).
    if (!hasParent) {
      MOBMENU.closeMenu();

      // Отмена действия по умолчанию
      // (например, чтобы не произошёл переход по ссылке, если
      // мы кликнули по элементу <a>).
      return false;
    }
  };
  MobMenu.prototype.addListeners = function () {
    var MOBMENU = this;
    // Привязка событий и функций-обработчиков
    this.toggleBtns.addEventListener("click", MOBMENU.toggleBtnClick.bind(MOBMENU));
    this.$body.addEventListener("click", MOBMENU.bodyClick(MOBMENU));
    itsoftApp.commonVars.$wrapper.addEventListener("click", function () {});
    Array.prototype.forEach.call(this.menuLinks, function (el) {
      el.addEventListener("click", function () {
        MOBMENU.closeMenu();
      });
    });
  };
  MobMenu.prototype.init = function () {
    if (!this.parent) {
      return false;
    }
    var MOBMENU = this;
    // Инициализируем слушатели событий
    this.addListeners();

    // Делегируем функцию в модуль windowScroll
    // (единая точка входа для события "scroll").
    DEBUG && console.log("%c--[module mobMenu] delegating scrollController to windowScroll module", "font-style: italic; color: #999");
    // itsoftApp.modules.windowScroll.addEvent(MOBMENU.scrollController.bind(MOBMENU));
    itsoftApp.modules.windowResize.addEvent(MOBMENU.resizeController.bind(MOBMENU));
  };
  new MobMenu();
  module.callback = MobMenu;
});
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
itsoftApp.createModule("navInstruction", ["pageLoad", "windowScroll", "windowResize"], function () {
  var module = this;
  var NavInstruction = function NavInstruction() {
    this.data = {
      names: [],
      blocks: [],
      "class": {
        active: '_active'
      }
    };
    this.list = document.querySelector('.js-nav-side');
    this.ul = this.list && this.list.querySelector('ul');
    this.links = this.list && this.list.querySelectorAll('[data-href]');
    if (this.list) {
      this.init();
    }
  };
  NavInstruction.prototype.getOffset = function () {
    var NAV = this;
    var listHeight = 0;
    var headerHeight = itsoftApp.calculations.headerHeight;
    return listHeight + +headerHeight;
  };
  NavInstruction.prototype.getNames = function () {
    var NAV = this;
    var _iterator = _createForOfIteratorHelper(NAV.links),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var link = _step.value;
        NAV.data.names.push(link.dataset.href);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  NavInstruction.prototype.setBlocks = function () {
    var NAV = this;
    var _iterator2 = _createForOfIteratorHelper(NAV.data.names),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var name = _step2.value;
        NAV.data.blocks.push(document.querySelector("#".concat(name)));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  NavInstruction.prototype.isBlockInWindow = function (el) {
    var NAV = this;
    var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      bottom = _el$getBoundingClient.bottom;
    var pointTop = top - NAV.getOffset();
    var pointBottom = bottom - NAV.getOffset();
    return pointTop < 1 && pointBottom > 1;
  };
  NavInstruction.prototype.setCurBlock = function () {
    var NAV = this;
    for (var index = 0; index < NAV.data.blocks.length; index++) {
      var block = NAV.data.blocks[index];
      var _iterator3 = _createForOfIteratorHelper(NAV.links),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var link = _step3.value;
          link.classList.remove(NAV.data["class"].active);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (NAV.isBlockInWindow(block)) {
        if (!NAV.links[index].classList.contains(NAV.data["class"].active)) {
          NAV.links[index].classList.add(NAV.data["class"].active);
        }
        if (NAV.ul.scrollLeft != NAV.links[index].parentNode.offsetLeft) {
          NAV.ul.scrollLeft = NAV.links[index].parentNode.offsetLeft;
        }
        break;
      }
    }
  };

  // NavInstruction.prototype.onScroll = function () {
  //     const NAV = this;

  //     NAV.setCurBlock();
  // };

  NavInstruction.prototype.init = function () {
    var NAV = this;
    if (NAV.list) {
      NAV.getNames();
      NAV.setBlocks();
      NAV.setCurBlock();
      var debouncedUpdate = itsoftApp.utils.debouncer(function () {
        NAV.setCurBlock();
      }, 50);
      itsoftApp.modules.pageLoad.addEvent(function () {
        // itsoftApp.modules.windowResize.addEvent(function () {
        //     debouncedUpdate()
        // });
        itsoftApp.modules.windowScroll.addEvent(function () {
          if (window.innerWidth > 1023) {
            NAV.setCurBlock();
          } else {
            debouncedUpdate();
          }
        });
      });
    }
  };
  new NavInstruction();
  module.callback = NavInstruction;
});
"use strict";

/**
 * Общая точка входа
 * для события полной загрузки страницы
 * (включая загрузку изображений, метрик и прочего).
 *
 * NOTE: Не путать с событием DOMContentLoaded
 * (оно же - $(document).ready(function() {...}) - в терминах jQuery).
 */
itsoftApp.createModule("pageLoad", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var singleFunctionFired = false;
  var timeoutInit = 120;
  var timeoutDelta = 80;
  var $window = itsoftApp.commonVars.$window;
  var flag = false;
  var body = document.body;

  /**
   * Функция, которая сработает лишь один раз,
   * и будет означать полную загрузку страницы.
   */
  var _singleLoadFunction = function singleLoadFunction() {
    var readyState = document.readyState;
    var func, timeoutCurrent;
    if (readyState !== "complete" || singleFunctionFired || !events.length) {
      return false;
    }
    DEBUG && console.log("%c[module pageLoad] window load event fired, count of functions to init: " + events.length + ", timeout for first func: " + timeoutInit + ", timeout delta for other: " + timeoutDelta, "color: purple");
    while (events.length > 0) {
      // Взять первый элемент массива,
      // и передать его в переменную.
      func = events.shift();

      // Будем запускать наши отложенные функции
      // через определённые промежутки времени, друг за другом с некоторым промежутком.
      // Мы уже знаем, что это функции,
      // поэтому доп. проверка не требуется.
      timeoutCurrent = timeoutCurrent ? timeoutCurrent + timeoutDelta : timeoutInit;
      setTimeout(func, timeoutCurrent);
    }
    singleFunctionFired = true;
    if (!flag) {
      $window.removeEventListener("load", _singleLoadFunction);
      flag = true;
      body.classList.add("js-loaded");
      if (body.hasAttribute("data-no-script")) {
        body.removeAttribute("data-no-script");
      }
    }
  };

  // Привязка собитий и функции-обработчика
  if (document.readyState === "complete") {
    _singleLoadFunction();
  } else {
    $window.addEventListener("load", _singleLoadFunction);
  }

  /**
   * Добавление переданной функции в очередь на выполнение,
   * либо немедленное исполнение функции, если страница уже полностью загружена.
   *
   * @param {function} func
   */
  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    // Если страница ещё не загружена полность, то добавляем в очередь
    if (!singleFunctionFired) {
      events.push(func);
      DEBUG && console.log("[module pageLoad] function added, count of functions to init now: " + events.length);

      // Если уже загружена, то просто вызываем переданную функцию
    } else {
      DEBUG && console.log("[module pageLoad] firing function immediately, because window load event already fired");
      func();
    }
  };

  // Доступ к фукциям
  // текущего модуля
  module.addEvent = addEvent;
});
// /**
//  * Всплывашки на сайте
//  *
//  * NOTE: Механизм, позволяющий отменить скролл для страницы, при открытой всплывашке,
//  * достаточно хитрый, поэтому лучше изучить данный модуль, чтобы досконально понимать, как он работает
//  */
// itsoftApp.createModule("popups", function() {
//     const module = this;
//     module.$wrapper = document.querySelector(".l-wrapper");
//     const popups = document.querySelectorAll("." + "popup"); // this.popupClass

//     if (!popups.length) { // TODO: Убрать или переделать, чтобы тесты прошли
//         return false;
//     }

//     // Локальные переменные
//     const $body = document.body;
//     const $document = document.documentElement;
//     // const activePopups = document.querySelectorAll("[data-bg-opened='true']");
//     // const popupBox = document.querySelector("#popup-box");
//     const fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
//     const hasFixedElems = fixedPageElems.length > 0;
//     const staticBackUrl = window.location.pathname;
//     const dAttrAutohide = "data-autohide";
//     const transitionEventEnd = itsoftApp.features.transitionEventEnd;
//     // const disabledButtons = document.querySelectorAll(".js-disabled");
//     const confirmation = document.querySelector(".js-confirmation");
//     // const save = document.querySelector(".js-save");
//     // const slider = {};
//     // const hashedPopups = document.querySelectorAll("data-hash");
//     window.currentOpenedPopup = undefined;
//     const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
//     const getScrTop = itsoftApp.utils.getScrTop;

//     let currentSlide;
//     let activeButton;
//     // let pageHash;

//     // if (hashedPopups.length > 0) {
//     //     pageHash = location.hash;
//     // }

//     const Breakpoint = {
//         mobile: 320,
//         tablet: 768,
//         desktop: 1280
//     };

//     const Popup = function (popup) {
//         if (!popup) {
//             try {
//                 throw new Error("Не передан обязательный аргумент popup");
//             } catch (err) {
//                 console.log(err);
//             }
//         }

//         this.state = {
//             closeButtonsAvailability: false,
//             openButtonsAvailability: false,
//             initedExemplar: false,
//             opened: false
//         };

//         this.popup = popup;
//         this.popupID = popup.id;
//         this.openPopupBtnSelector = ".js-open-popup[data-popup-id='" + popup.id + "']";
//         this.closePopupBtnSelector = ".js-close-popup[data-popup-id='" + popup.id + "']";
//         this.openPopupBtns = document.querySelectorAll(this.openPopupBtnSelector);
//         this.closePopupBtns = document.querySelectorAll(this.closePopupBtnSelector);
//         this.lazyImages = [];
//         this.popupClass = "popup";
//         this.openedClass = "is-opened";
//         this.dAttrSelector = "data-popup-selector";
//         this.dAttrBgClose = "data-bg-close";
//         this.hiddenClass = "g-hidden";
//         this.evNameOpen = "popups:open";
//         this.evNameClose = "popups:close";
//         this.wrapperAbsClass = "is-abs";
//         this.wrapperOverflow = "is-over";
//         this.popupOpenedClass = "is-popup-opened";
//         this.dAttrUrl = "data-url";
//         this.dAttrHide = "data-hide";
//         this.dAttrClose = "data-close-popup";
//         this.hideDelayDefault = 3500;

//         this.init();
//     };

//     Popup.prototype.globalState = {
//         listenersAdded: false,
//         historyPushed: false,
//     };

//     Popup.prototype.openedPopups = [];
//     Popup.prototype.autohidePopups = [].filter.call(popups, function (el) {
//         return el.matches("[" + dAttrAutohide + "='true']");
//     });

//     Popup.prototype.lastOpenedPopup = null;

//     Popup.prototype.detachEvents = function () {
//         this.popup.removeEventListener(this.evNameOpen, this.popupOpen);
//         this.popup.removeEventListener(this.evNameClose, this.popupClose);
//         this.popup.removeEventListener("click", this.popupClick);

//         Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
//             openBtn.removeEventListener("click", this.openPopupBtnClick);
//         });

//         Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
//             closeBtn.removeEventListener("click", this.closePopupBtnClick);
//         });
//     };

//     Popup.prototype.init = function () {
//         const POPUP = this;

//         POPUP.lazyImages = POPUP.popup.querySelectorAll(".lazyload-call");

//         /**
//          * Обработчик нажатий на кнопки клавиатуры.
//          * Необходим для того, чтобы можно было закрыть всплывашку кнопкой ESC.
//          *
//          * NOTE: Так как возможны случаи, когда открыто несколько всплывах,
//          * то закрываем их одна за одной, начиная с той, у которой наибольший z-index.
//          *
//          * @param  {object} e Event
//          */
//         Popup.prototype.keyController = function (evt) {
//             // Обрабатываем только нажатие на ESC,
//             // а все остальные нажатия игнорируем.
//             if (evt.keyCode !== 27) {
//                 return;
//             }

//             if (!POPUP.openedPopups.length) {
//                 return;
//             }

//             let maxZI = 0;

//             Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
//                 const popup = el;
//                 let zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

//                 if (isNaN(zi)) {
//                     zi = 0;
//                 }
//                 if (zi >= maxZI) {
//                     maxZI = zi;
//                     POPUP.lastOpenedPopup = popup;
//                 }
//             });

//             if (!POPUP.lastOpenedPopup) {
//                 return;
//             }

//             // Закрываем только последнюю открытую всплывашку
//             if (!POPUP.lastOpenedPopup.hasAttribute("data-save")) {
//                 POPUP.lastOpenedPopup.dispatchEvent(window.closeEvent);
//             }
//         };

//         if (!this.globalState.listenersAdded) {
//             if (window.CustomEvent && typeof window.CustomEvent === "function") {
//                 window.closeEvent = new CustomEvent(this.evNameClose, {detail: {name: "Закрытие"}});
//                 window.openEvent = new CustomEvent(this.evNameOpen, {detail: {name: "Открытие"}});
//             } else {
//                 window.closeEvent = document.createEvent("CustomEvent");
//                 window.openEvent = document.createEvent("CustomEvent");
//                 window.closeEvent.initCustomEvent(this.evNameClose, true, true, {name: "Закрытие"});
//                 window.openEvent.initCustomEvent(this.evNameOpen, true, true, {name: "Открытие"});
//             }

//             window.addEventListener("beforeunload", this.windowUnload);
//             window.addEventListener("keyup", this.keyController);

//             this.globalState.listenersAdded = true;
//         }

//         if (this.closePopupBtns.length > 0) {
//             this.state.closeButtonsAvailability = true;
//         }

//         if (this.openPopupBtns.length > 0) {
//             this.state.openButtonsAvailability = true;
//         }

//         /**
//          * Клик по кнопкам, открывающим всплывахи.
//          * Какую именно всплывашку открыть - обозначено в data- атрибуте.
//          */
//         Popup.prototype.openPopupBtnClick = function (evt) {
//             evt.preventDefault();

//             const self = this;
//             const dataSlide = self.getAttribute("data-slide");
//             // const selector = self.getAttribute(POPUP.dAttrSelector);

//             dataSlide ? currentSlide = dataSlide : currentSlide = undefined;

//             // if (selector) {
//                 // if (popup) {
//             POPUP.popup.dispatchEvent(window.openEvent);
//                 // }
//             // }

//             // else {
//             //     const popupType = self.getAttribute("data-popup-type")

//             //     if (popupType = "image") {
//             //         createImagePopup(self);
//             //     } else {
//             //         return;
//             //     }
//             // }
//         };

//         /**
//          * Клик по кнопкам, закрывающим всплывашку.
//          * Будет закрыта "родительская" всплывашка
//          * (поиск по ближайшему родителю с нужным классом).
//          */
//         Popup.prototype.closePopupBtnClick = function () {
//             const self = this;
//             let checkbox = null;
//             // const popup = self.closest("." + popupClass);
//             const onBoxCheck = function (evt) {
//                 if (evt.currentTarget.classList.contains("js-error")) {
//                     checkbox.classList.remove("js-error");
//                     checkbox.removeEventListener("change", onBoxCheck);
//                 }
//             };

//             if (this.classList.contains("js-save")) {
//                 if (self.hasAttribute("data-checkbox")) {
//                     const checkboxID = self.getAttribute("data-checkbox");
//                     checkbox = confirmation.querySelector(checkboxID);

//                     if (!checkbox.checked) {
//                         checkbox.classList.add("js-error");
//                         checkbox.addEventListener("change", onBoxCheck);
//                         return;
//                     }
//                 }

//                 itsoftApp.modules.cookie.setCookie(this);
//             }

//             POPUP.popup.dispatchEvent(window.closeEvent);
//         };

//         /**
//          * Все действия, связанные с открытием всплывашки
//          */
//         Popup.prototype.popupOpen = function () {
//             const self = this;

//             if (self.classList.contains(POPUP.openedClass)) {
//                 return;
//             }

//             if (POPUP.lazyImages.length > 0) {
//                 if (!POPUP.lazyImages[0].getAttribute("data-ll-status")) {
//                     Array.prototype.forEach.call(POPUP.lazyImages, function (image) {
//                         LazyLoad.load(image, window.llCallRequestOptions);
//                     })
//                 }
//             }

//             // Если до этого уже были открыты всплывашки,
//             // то вычисляем наибольший z-index, и присваиваем его
//             // новой открывающейся всплывашке.
//             // Иначе возможны ситуации, когда всплывашка открылась, но из-за расположения по вёрстке
//             // оказалась ниже (за счет одинакового z-index), и в итоге её не видно.

//             if (POPUP.openedPopups.length > 0) {
//                 let maxZI = 0;

//                 Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
//                     const popup = el;

//                     if (popup.getAttribute("data-ignore") === "true") {
//                         return;
//                     }

//                     let zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

//                     if (isNaN(zi)) {
//                         zi = 0;
//                     }

//                     maxZI = Math.max(maxZI, zi);
//                 });

//                 if (maxZI > 0) {
//                     self.style.zIndex = maxZI + 1;
//                     DEBUG && console.log("%c--[module popups] added z-index " + (maxZI + 1) + ", because there was another opened popups", "font-style: italic; color: #999");
//                 }
//             }

//             // Вычисляем текущую величину прокрутки страницы
//             // (делаем это до того, как будут произведены какие-либо дальнейшие действия).
//             let scrTop = getScrTop();
//             DEBUG && console.log("[module popups] scrTop: " + scrTop);

//             // Если есть fixed элементы на странице,
//             // то задаём им padding-right, равный ширине полосы прокрутки.
//             // Без этого такие элементы будут дёргаться,
//             // так как в процессе открытия всплывашки слегка меняются общие стили страницы.
//             if (hasFixedElems) {
//                 let scrollbarWidth = getScrollbarWidth();
//                 DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);

//                 Array.prototype.forEach.call(fixedPageElems, function (el) {
//                     el.style.paddingRight = scrollbarWidth + "px";
//                 });
//             }

//             // NOTE: Это из-за плашки browser-update,
//             // которая задаёт <html> ненулевой margin-top,
//             // (в случае, если плашка об устаревшем браузере показана)
//             // из-за которого страница "прыгает".
//             const mt = parseInt(getComputedStyle($document)["marginTop"], 10);
//             const mtExists = !isNaN(mt) && mt !== 0;
//             if (mtExists) {
//                 scrTop -= mt;
//             }

//             // Основная магия происходит здесь.
//             // Элементу .l-wrapper задаётся класс, который одновременно
//             // убирает полосу прокрутки у <body> (так как .l-wrapper теперь position: absolute),
//             // и добавляет полосу прокрутки у самого .l-wrapper (за счёт overflow: auto).
//             // После этого остаётся прокрутить элемент .l-wrapper до того же значения,
//             // которое было до этого у <body> (мы посчитали эту величину ранее).
//             // Происходит это достаточно быстро, чтобы пользователь ничего не заметил.
//             if (module.$wrapper) {
//                 module.$wrapper.classList.add(POPUP.wrapperAbsClass);
//                 module.$wrapper.scrollTop = scrTop;
//             }

//             // NOTE: Это из-за плашки browser-update
//             if (mtExists) {
//                 $document.scrollTop = 0;
//             }

//             // Это для отсутсвия скролла у <body> в некоторых редких случаях
//             // (например, если висит плашка об устаревшем браузере)
//             if (!POPUP.popup.hasAttribute("data-scroll")) {
//                 $body.classList.add(POPUP.popupOpenedClass);
//             }

//             // Здесь предусмотрена возможность автоматически скрывать некоторые всплывашки
//             // при открытии других всплывашек.
//             // Для этого им нужно задать определённый data- атрибут
//             // (указан в локальных переменных в начале модуля).
//             let autohidePopupsOpened = [].filter.call(POPUP.autohidePopups, function (el) {
//                 return el.classList.contains(POPUP.openedClass);
//             });

//             if (autohidePopupsOpened.length > 0) {
//                 DEBUG && console.log("[module popups] hided " + autohidePopupsOpened.length + " popups with " + dAttrAutohide + "=true");
//                 Array.prototype.forEach.call(autohidePopupsOpened, function (el) {
//                     el.classList.remove(POPUP.openedClass);
//                 });
//             }

//             if (window.currentOpenedPopup) {
//                 window.currentOpenedPopup = undefined;
//             }

//             // Далее, делаем нашу всплывашку видимой (за счёт класса)
//             self.classList.add(POPUP.openedClass);
//             window.currentOpenedPopup = self;
//             POPUP.openedPopups.push(self);
//             POPUP.state.opened = true;

//             let isIncludeSlider = self.hasAttribute("data-slider");

//             if (isIncludeSlider) {
//                 if (self.getAttribute("data-slider") !== "true") {
//                     const sliderContainer = self.closest(".js-slider");
//                     self.setAttribute("data-slider", "true");
//                     itsoftApp.modules.slidersLibrary.callback(sliderContainer, undefined, undefined, self.getAttribute("data-slider-name"), currentSlide);
//                 } else {
//                     itsoftApp.modules.slidersLibrary.slider[self.getAttribute("data-slider-name")].slideTo(+currentSlide);
//                 }
//             }

//             if (self.hasAttribute("data-destroy-device")) {
//                 if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth) {
//                     itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth = true;
//                     itsoftApp.calculations.viewWidth = itsoftApp.utils.getViewportSize();
//                 }

//                 const onWindowResize = function () {
//                     if (itsoftApp.calculations.viewWidth >= Breakpoint[self.getAttribute("data-destroy-device")]) {
//                         self.dispatchEvent(window.closeEvent);
//                         window.removeEventListener("resize", onWindowResize);
//                         // todo: нужно попробовать реализовать через windowResize, с возможностью удалить из очереди по необходимости
//                     }
//                 };

//                 window.addEventListener("resize", onWindowResize);
//             }

//             // Здесь предусмотрена возможность
//             // закрыть текущую всплывашку через определённый промежуток времени
//             // (например, всплывашка с коротким информационным сообщением).
//             // Для этого им нужно задать определённый data- атрибут
//             // (указан в локальных переменных в начале модуля).
//             let hideDelay = self.getAttribute(POPUP.dAttrHide);
//             if (hideDelay) {
//                 hideDelay = parseInt(hideDelay, 10);
//                 hideDelay = isNaN(hideDelay) ? POPUP.hideDelayDefault : hideDelay;
//                 setTimeout(function () {
//                     self.dispatchEvent(window.closeEvent);
//                 }, hideDelay);
//             }

//             // При необходимости, можно управлять адресной строкой браузера
//             const urlToChange = self.getAttribute(POPUP.dAttrUrl);
//             if (urlToChange) {
//                 POPUP.changePageUrl(urlToChange);
//             }

//             DEBUG && console.log("[module popups] opened popup: " + (self.id ? "#" + self.id : "." + self.className));
//         };

//         /**
//          * Все действия, связанные с закрытием всплывашки
//          */
//         Popup.prototype.popupClose = function () {
//             const self = this;
//             if (!POPUP.state.opened) {
//                 return;
//             }

//             if (activeButton) { /* ??? */
//                 activeButton.classList.remove("js-active");
//                 activeButton = undefined;
//             } /* ??? */

//             self.classList.remove(POPUP.openedClass);

//             // Так как вплывашка прилетает не мгновенно, а плавно,
//             // то сразу делать возврат страницы к исходному состоянию нельзя
//             // (будут видны артефакты, сязанные с переводом полосы прокрутки
//             // от body к .l-wrapper и обратно).
//             const end = function () {
//                 setTimeout(function () {
//                     POPUP.clearScrollStyles();
//                 }, 200);

//                 if (transitionEventEnd) {
//                     self.removeEventListener(transitionEventEnd, end);
//                     POPUP.openedPopups.pop();
//                 }

//                 POPUP.state.opened = false;
//             };

//             // Для современных браузеров, где работает свойство transition,
//             // вешаем обработчик на событие transitionEnd.
//             if (transitionEventEnd) {
//                 self.addEventListener(transitionEventEnd, end);

//             // Для старых браузеров, сразу вызываем функцию.
//             } else {
//                 end();
//             }

//             // При необходимости,
//             // меняем (возвращаем обратно)
//             // адрес в строке браузера.
//             const urlToChange = self.getAttribute(POPUP.dAttrUrl);
//             if (urlToChange) {
//                 POPUP.changePageUrl("back");
//             }

//             DEBUG && console.log("[module popups] closed popup: " + (self.id ? "#" + self.id : "." + self.className));
//         };

//         /**
//          * Возврат страницы к исходному
//          * (до того, как была открыта хоть одна всплывшка)
//          * состоянию.
//          *
//          * @param  {boolean} force Часть функционала можно исполнить принудительно
//          */
//         Popup.prototype.clearScrollStyles = function (force) {
//             if (force == null) {
//                 force = false;
//             }

//             // Функция выполнится, если не осталось открытых всплывашек
//             // (потому что их может быть несколько, и закрытие одной не означает закрытие всех),
//             // либо принудительно (в редких случаях).
//             const hasOpenedPopups = POPUP.openedPopups.length > 0;
//             if (hasOpenedPopups && !force) {
//                 return;
//             }

//             // Вычисляем текущую величину прокрутки страницы
//             // (функция getScrTop достаточно "умная", чтобы посчитать текущий скролл при любом состоянии).
//             // Это нужно сделать до того, как произойдут дальнейшие действия.
//             // $wrapper.classList.add(wrapperOverflow);
//             let scrTop = getScrTop();
//             DEBUG && console.log("%c[module popups] (clearScrollStyles) scrTop: " + scrTop + ". force: " + force, "color: #999");
//             // $wrapper.classList.remove(wrapperOverflow);
//             // Возвращаем структурные элементы .l-wrapper и body
//             // к исходному состоянию, убираем все необходимые классы.
//             if (module.$wrapper) {
//                 module.$wrapper.classList.remove(POPUP.wrapperAbsClass);
//             }

//             $body.classList.remove(POPUP.popupOpenedClass);

//             // Если на странице есть fixed элементы,
//             // то убираем ранее заданное значение radding-right
//             if (hasFixedElems) {
//                 Array.prototype.forEach.call(fixedPageElems, function (el) {
//                     el.style.paddingRight = "";
//                 });
//             }

//             // NOTE: Это из-за плашки browser-update
//             const mt = parseInt(getComputedStyle($document)["marginTop"], 10);
//             const mtExists = !isNaN(mt) && mt !== 0;
//             if (mtExists) {
//                 scrTop += mt;
//             }

//             // Наконец, пролистываем body до того значения,
//             // который был у .l-wrapper.
//             // Происходит это довольно быстро, так что пользователь не заметит разницы.
//             $document.scrollTop = scrTop;
//         };

//         /**
//          * Обработчик события "click", который определяет,
//          * по какому именно мы кликнули элементу, и, если это
//          * "пустое пространство" за самой всплывахой,
//          * то закрываем её.
//          *
//          * NOTE: Можно отменить данное действие, задав дополнительный data- атрибут
//          *
//          * @param  {object} e Event
//          */
//         Popup.prototype.popupClick = function (evt) {
//             const self = this;
//             if (evt.target === self && self.getAttribute(POPUP.dAttrBgClose) !== "false") {
//                 self.dispatchEvent(window.closeEvent);
//             }
//         };

//         /**
//          * Так как прокрутку страницы мы "отменяем" хитрым способом,
//          * то при попытке перезагрузить страницу, на которой уже открыта всплывашка,
//          * нас перекинет наверх страницы.
//          * Это подбешивает, поэтому привязываем данную функцию на событие закрытия (обновления)
//          * страницы. Мы принудительно возвращаем страницу к её исходному состоянию,
//          * тем самым нас не перекинет наверх после перезагрузки.
//          */
//         Popup.prototype.windowUnload = function () {
//             POPUP.clearScrollStyles(true);
//         };

//         this.popup.addEventListener(POPUP.evNameOpen, POPUP.popupOpen);
//         this.popup.addEventListener(POPUP.evNameClose, POPUP.popupClose);
//         this.popup.addEventListener("click", POPUP.popupClick);

//         Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
//             openBtn.addEventListener("click", POPUP.openPopupBtnClick);
//         });

//         Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
//             closeBtn.addEventListener("click", POPUP.closePopupBtnClick);
//         });

//         if (this.popup.getAttribute("data-bg-opened") == "true") {
//             var dAttrSave = this.popup.getAttribute("data-save");
//             if (dAttrSave && !(itsoftApp.modules.cookie.getCookie(this.popup))) {
//                 this.popup.dispatchEvent(window.openEvent);
//                 DEBUG && console.log("data-bg open event");
//             } else if (!dAttrSave) {
//                 this.popup.dispatchEvent(window.openEvent);
//                 DEBUG && console.log("data-bg else open event");
//             } else {
//                 this.popup.dispatchEvent(window.closeEvent);
//             }
//         }

//         if (!this.state.initedExemplar) {
//             this.state.initedExemplar = true;
//         }
//     };
//     // Перемещаем все всплывашки в конец <body>.
//     // Это нужно для того, чтобы при открытии всплывашки,
//     // событие "scroll" всплывало до <body> и <html>,
//     // но НЕ всплывало до <div class="l-wrapper">.
//     // Это важно, так как при открытии всплывашки прокрутка
//     // убирается у <body> и появляется у <div class="l-wrapper">.
//     // Тем самым, мы "отменяем скролл".
//     //
//     // NOTE: На самом деле, отменить стандартный скролл браузера нельзя
//     // (иначе не было бы всей этой истории).
//     // Можно отменить, например, всплытие события "click" или действие по умолчанию для него.
//     // Но ряд событий отменить или прервать всплытие нельзя.

//     /**
//      * Изменение адресной строки браузера при открытии всплывашки
//      * (по необходимости).
//      * Доп. инфа:
//      * http://stackoverflow.com/questions/824349/modify-the-url-without-reloading-the-page
//      *
//      * @param  {string} url     Новый адрес
//      * @param  {string} popupID Необходимо для отработки случая, когда мы перешли на страницу по прямому адресу
//      */
//     Popup.prototype.changePageUrl = function (url) {
//         // Если браузер не поддерживает работу с историей,
//         // то прерываем выполнение функции.
//         if (!window.history || typeof window.history.pushState !== "function" || typeof url !== "string") {
//             DEBUG && console.log("%c[module popups] !window.history || typeof window.history.pushState != function || typeof url != string", "color: red");
//             return;
//         }

//         // Переход "вперёд" по истории браузера ...
//         if (url !== "back") {
//             DEBUG && console.log("%c[module popups] trying to change page url to: " + url, "font-style: italic");
//             window.history.pushState(false, false, url);
//             this.globalState.historyPushed = true;

//         // ... переход "назад"
//         } else {
//             // Случай, когда мы до этого открыли всплывашку и перешли "вперёд"
//             if (this.globalState.historyPushed) {
//                 DEBUG && console.log("%c[module popups] trying to go back in history", "font-style: italic");
//                 window.history.back();

//             // Случай, когда до этого не было перехода "вперёд"
//             // (например, пользователь перешёл по прямой ссылке).
//             } else if (typeof this.popupID === "string") {
//                 var urlToChange = staticBackUrl;
//                 urlToChange = staticBackUrl.substring(0, staticBackUrl.length - this.popupID.length - 1);
//                 DEBUG && console.log("%c[module popups] replacing page url to " + urlToChange, "font-style: italic; color: orange");
//                 window.history.replaceState(false, false, urlToChange);
//             }
//         }
//     };

//     Array.prototype.forEach.call(popups, function (popup) {
//         new Popup(popup);
//     });

//     module.callback = {
//         popup: Popup
//     }
// });
"use strict";
"use strict";

itsoftApp.createModule("saveCookies", ["disclaimer"], function () {
  var saveCookieButtons = document.querySelectorAll(".js-save-button");
  var cookies = document.querySelector(".js-cookies");
  var bodyEnd = document.querySelector(".js-padding-bottom");
  var disclaimer = document.querySelector(".js-disclaimer");
  window.cookiesState = "inactive";
  var saveCookie = function saveCookie(evt) {
    evt.preventDefault();
    var button = evt.currentTarget;
    if (button.hasAttribute("data-close")) {
      var plate = button.closest("[data-plate=" + button.getAttribute("data-close") + "]");
      plate && plate.classList.add("is-hidden");
    }
    itsoftApp.modules.cookie.setCookie(button);
    window.cookiesState = "inactive";
    bodyEnd.style.paddingBottom = 0;
    disclaimer.style.bottom = "0px";
  };
  if (cookies && saveCookieButtons.length > 0 && !itsoftApp.modules.cookie.getCookie(cookies)) {
    window.cookiesState = "active";
    cookies.classList.remove('is-hidden');
    if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.cookieHeight) {
      itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.cookieHeight = true;
      itsoftApp.calculations.cookieHeight = itsoftApp.utils.getCookieHeight();
    }
    bodyEnd.style.paddingBottom = itsoftApp.calculations.cookieHeight + "px";
    Array.prototype.forEach.call(saveCookieButtons, function (button) {
      button.addEventListener("click", saveCookie);
    });
  } else if (disclaimer) {
    disclaimer.style.bottom = "0px";
  }
});
"use strict";

itsoftApp.createModule("scrollActions", ["startLoad"], function () {
  var module = this;
  var registeredPlugin = false;
  var registeredScrollTriggerPlugin = false;
  var initScrollActions = function initScrollActions(targetCb, scrollTriggerFlag, cb) {
    var initScrollExemplar = function initScrollExemplar() {
      if (!registeredPlugin) {
        registeredPlugin = true;
        if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
          gsap.registerPlugin(ScrollTrigger);
        }
      }
      if (cb && typeof cb === "function") {
        cb();
      } else {
        // ScrollTrigger.clearScrollMemory();
        // ScrollTrigger.normalizeScroll(true);

        ScrollTrigger.matchMedia({
          "(min-width: 1024px)": function minWidth_1024px() {
            if (targetCb.classList.contains('js-anim-help')) {
              var container = targetCb;
              var items = container.querySelectorAll('.js-anim-help-col');
              var value = window.innerWidth / 10;
              var tl = gsap.timeline({
                scrollTrigger: {
                  trigger: container,
                  scrub: true,
                  start: "top top",
                  end: function end() {
                    return "+=" + window.innerHeight;
                  }
                }
              });
              for (var index = 0; index < items.length; index++) {
                var element = items[index];
                element.style.transitionDuration = '0s';
                var valueY = value;
                if (index === 0) {
                  valueY = value / 1.5;
                }
                if (index === 2) {
                  valueY = value / 3;
                }
                tl.fromTo(element, {
                  y: valueY
                }, {
                  y: -valueY
                }, "<");
              }
            }
            if (targetCb.classList.contains('js-anim-variants')) {
              var _container = targetCb;
              var item = _container.querySelector('.js-anim-variants-item');
              var _value = 100;
              var _tl = gsap.timeline({
                scrollTrigger: {
                  trigger: _container,
                  scrub: true,
                  start: 'top top',
                  end: function end() {
                    return "+=" + _container.clientHeight;
                  }
                }
              });
              var _valueY = _value;
              _tl.fromTo(item, {
                y: -_valueY
              }, {
                y: _valueY
              }, "<");
            }
            if (targetCb.classList.contains('js-anim-test')) {
              var _container2 = targetCb;
              var _items = _container2.querySelectorAll('.js-anim-test-item');
              var _value2 = 100;
              var _tl2 = gsap.timeline({
                scrollTrigger: {
                  trigger: _container2,
                  scrub: true,
                  start: "".concat(-window.innerHeight / 2.5, " top"),
                  end: function end() {
                    return "+=" + _container2.clientHeight;
                  }
                }
              });
              for (var _index = 0; _index < _items.length; _index++) {
                var _element = _items[_index];
                var valueX = _value2;
                var _valueY2 = _value2;
                if (_index === 0) {
                  valueX = -_value2;
                  _valueY2 = -_value2;
                }
                if (_index === 1) {
                  valueX = _value2;
                  _valueY2 = -_value2;
                }
                if (_index === 2) {
                  valueX = -_value2;
                  _valueY2 = _value2;
                }
                _tl2.from(_element, {
                  x: valueX,
                  y: _valueY2
                }, "<");
              }
            }
            if (targetCb.classList.contains('js-anim-advantages')) {
              var _container3 = targetCb;
              var _items2 = _container3.querySelectorAll('.js-anim-advantages-item');
              var _value3 = window.innerWidth / 5;
              var _tl3 = gsap.timeline({
                scrollTrigger: {
                  trigger: _container3,
                  scrub: true,
                  start: "".concat(-window.innerHeight / 2.5, " top"),
                  end: function end() {
                    return "+=" + _container3.clientHeight;
                  }
                }
              });
              for (var _index2 = 0; _index2 < _items2.length; _index2++) {
                var _element2 = _items2[_index2];
                var _valueY3 = _value3;
                if (_index2 === 0 || _index2 === 2 || _index2 === 4) {
                  _valueY3 = _value3 / 3;
                }
                _tl3.fromTo(_element2, {
                  y: _valueY3
                }, {
                  y: -_valueY3
                }, "<");
              }
            }
            if (targetCb.classList.contains('js-anim-about')) {
              var startAnimFirst = function startAnimFirst(ind) {
                var img = _items3[ind].querySelector('.about__img');
                var text = _items3[ind].querySelector('.about__col');
                _tl4.to(img, {
                  scale: curScale,
                  ease: 'linear'
                });
                _tl4.to(text, {
                  y: -itemsHeight[ind],
                  ease: 'linear'
                }, "<");
              };
              var startAnimLast = function startAnimLast(ind) {
                _tl4.to(_items3[ind], {
                  y: -itemsHeight[ind] * ind,
                  ease: 'linear'
                }, "<");
              };
              var _container4 = targetCb;
              var _items3 = _container4.querySelectorAll('.js-anim-about-item');
              var itemsHeight = [];
              var allItemsHeight = 0;
              var curScale = 0.5;
              for (var _index3 = 0; _index3 < _items3.length; _index3++) {
                var _element3 = _items3[_index3];
                itemsHeight.push(_element3.clientHeight);
              }
              for (var _index4 = 0; _index4 < itemsHeight.length; _index4++) {
                var _element4 = itemsHeight[_index4];
                allItemsHeight += _element4;
              }
              var _tl4 = gsap.timeline({
                scrollTrigger: {
                  trigger: _container4,
                  pin: true,
                  scrub: true,
                  start: 'top top',
                  end: function end() {
                    return "+=" + (allItemsHeight - itemsHeight[_items3.length - 1]);
                  },
                  onUpdate: function onUpdate(self) {
                    if (self.progress > 0.5) {
                      _items3[_items3.length - 1].classList.add('_active');
                    } else {
                      _items3[_items3.length - 1].classList.remove('_active');
                    }
                  }
                }
              });
              startAnimFirst(0);
              startAnimLast(_items3.length - 1);
            }
            if (targetCb.classList.contains('js-anim-about-inflammation')) {
              var _container5 = targetCb;
              var _items4 = _container5.querySelectorAll('.js-anim-about-inflammation-item');
              var _value4 = window.innerWidth / 10;
              var _tl5 = gsap.timeline({
                scrollTrigger: {
                  trigger: _container5,
                  scrub: true,
                  start: "".concat(-window.innerHeight / 1.5, " top"),
                  end: function end() {
                    return "+=" + _container5.clientHeight;
                  }
                }
              });
              for (var _index5 = 0; _index5 < _items4.length; _index5++) {
                var _element5 = _items4[_index5];
                _element5.style.transitionDuration = '0s';
                var _valueY4 = _value4;
                if (_index5 === 1) {
                  _valueY4 = _value4 / 3;
                }
                if (_index5 === 2) {
                  _valueY4 = _value4 / 1.5;
                }
                _tl5.fromTo(_element5, {
                  y: _valueY4
                }, {
                  y: -_valueY4
                }, "<");
              }
            }

            // window.lennis.on('scroll', ScrollTrigger.update)
          }
        });
        if (targetCb.classList.contains('js-growth-inflammation')) {
          var container = document.querySelector('.js-growth-inflammation-wrapper');
          var imageWrapper = container.querySelector('.js-growth-inflammation-img');
          var folder = window.innerWidth > 767 ? 'growth-inflammation' : 'growth-inflammation-mob';
          var tl = gsap.timeline({
            scrollTrigger: {
              trigger: container,
              scrub: true,
              start: "top-=".concat(window.innerHeight / 2, " top"),
              end: function end() {
                return "+=" + container.clientHeight;
              }
            }
          });
          console.time();
          for (var index = 1; index < 81; index++) {
            var image = document.createElement('IMG');
            image.src = "/media/images/".concat(folder, "/").concat(index, ".jpg");
            imageWrapper.append(image);
            tl.to(image, {
              visibility: 'visible',
              ease: 'linear'
            });
          }
          console.timeEnd();
        }

        // if (window.lennis) {
        //     window.lennis.on('scroll', ScrollTrigger.update);
        // }

        targetCb && typeof targetCb === "function" && targetCb();
      }
    };
    new itsoftApp.modules.startLoad.callback(initScrollExemplar, itsoftApp.libraries.scrollTrigger);
  };
  module.callback = initScrollActions;
});
"use strict";

itsoftApp.createModule("scrollTo", ["windowResize", "startLoad"], function () {
  var module = this;
  var sideNav = false && document.querySelector(".js-nav-side");
  var ResponsiveScroll = function ResponsiveScroll() {
    this.duration = 1;
    this.init();
  };
  var getSidenavHeight = function getSidenavHeight() {
    var sideNavHeight = sideNav ? sideNav.offsetHeight : 0;
    return sideNavHeight;
  };
  ResponsiveScroll.prototype.scrollTo = function (hash) {
    var RESPONSIVE_SCROLL = this;
    // let mm = gsap.matchMedia();

    itsoftApp.utils.getHeaderFixedHeight();
    gsap.to(window, {
      duration: RESPONSIVE_SCROLL.duration,
      scrollTo: {
        y: hash,
        offsetY: itsoftApp.calculations.headerFixedHeight
      }
    });

    // mm.add("(min-width: 1024px)", () => {
    //     gsap.to(window, {
    //         duration: RESPONSIVE_SCROLL.duration,
    //         scrollTo: {
    //             y: hash,
    //             offsetY: itsoftApp.calculations.headerFixedHeight,
    //         }
    //     })
    // });

    // mm.add("(max-width: 1023px)", () => {
    //     gsap.to(window, {
    //         duration: RESPONSIVE_SCROLL.duration,
    //         scrollTo: {
    //             y: hash,
    //             offsetY: itsoftApp.calculations.headerFixedHeight + getSidenavHeight(),
    //         }
    //     })
    // });
  };
  ResponsiveScroll.prototype.onLinkClick = function (evt) {
    evt.preventDefault();
    var RESPONSIVE_SCROLL = this;
    var target = evt.currentTarget;
    var hash = target.getAttribute("href");

    // Доработка якорых ссылок на странице Инструкция
    var navSide = document.querySelector('.js-nav-side');
    if (navSide) {
      var name = target.getAttribute('data-href');
      if (name) {
        var instructionBody = document.querySelector('.instruction__body');
        var curBlock = instructionBody.querySelector("#".concat(name));
        var spollers = instructionBody.querySelectorAll('.js-accordion-item--active');
        var curSpoller = curBlock.querySelector('.js-accordion-item');

        // for (const el of spollers) {
        //     const activeSpoller = spollers[[...spollers].indexOf(curSpoller)]
        //     if (el !== activeSpoller) {
        //         el.instance.closeAccordion(now = true);
        //     }
        // }
        if (!curSpoller.instance.state.opened) {
          curSpoller.instance.openAccordion();
        }
      }
    }
    // Доработка якорых ссылок на странице Инструкция

    if (!itsoftApp.libraries.scrollToPlugin.loaded) {
      new itsoftApp.modules.startLoad.callback(function () {
        RESPONSIVE_SCROLL.scrollTo(hash);
      }, itsoftApp.libraries.scrollToPlugin);
    } else {
      RESPONSIVE_SCROLL.scrollTo(hash);
    }
  };
  ResponsiveScroll.prototype.init = function () {
    var RESPONSIVE_SCROLL = this;
    if (itsoftApp.state.hashActive) {
      new itsoftApp.modules.startLoad.callback(function () {
        RESPONSIVE_SCROLL.scrollTo(itsoftApp.state.hash);
      }, itsoftApp.libraries.scrollToPlugin);
    }
    var links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    /* Проходимся по всем элементам, у которых в href есть хэш */
    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener("click", RESPONSIVE_SCROLL.onLinkClick.bind(RESPONSIVE_SCROLL));
    });
  };
  itsoftApp.modules.pageLoad.addEvent(function () {
    new ResponsiveScroll();
  });
  module.callback = ResponsiveScroll;
});
"use strict";

itsoftApp.createModule("slidersLibrary", function () {
  var module = this;
  var Slider = function Slider(el, sliderSettings, cb, currentSlide) {
    this.el = el;
    this.sliderSettings = sliderSettings;
    this.currentSlide = currentSlide;
    this.sliderContainer = el.querySelector(".swiper-container");
    this.navigation = el.querySelector(".swiper-navigation");
    this.pagination = el.querySelector(".swiper-pagination");
    this.scrollbar = el.querySelector(".swiper-scrollbar");
    this.dataDevice = el.getAttribute("data-destroy-device");
    this.destroyDirection = el.getAttribute("data-destroy-direction");
    this.withoutNavigation = el.hasAttribute("data-without-navigation");
    this.withoutPagination = el.hasAttribute("data-without-pagination");
    this.isInitialized = false;
    this.initializedSlider = null;
    this.init();
  };
  Slider.prototype.init = function () {
    var SLIDER = this;
    var outerNavName = SLIDER.sliderContainer.getAttribute("data-slider-name") || SLIDER.sliderSettings && SLIDER.sliderSettings.sliderName || "";
    SLIDER.outerNavigation = document.querySelector("[data-slider-nav='" + outerNavName + "']");
    Slider.prototype.onWindowResize = function () {
      var SLIDER = this;
      if (SLIDER.destroyDirection === "from" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() >= +SLIDER.dataDevice) {
        if (SLIDER.isInitialized === true) {
          SLIDER.destroySlider();
        }
      } else if (SLIDER.destroyDirection === "to" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() <= +SLIDER.dataDevice) {
        if (SLIDER.isInitialized === true) {
          SLIDER.destroySlider();
        }
      } else {
        if (SLIDER.isInitialized === false) {
          SLIDER.initSlider();
          DEBUG && console.log("init", ' ' + outerNavName);
        }
      }
    };
    Slider.prototype.createSlider = function () {
      if (!SLIDER.sliderSettings) {
        return;
      }
      if (!SLIDER.withoutNavigation && (SLIDER.navigation || SLIDER.outerNavigation)) {
        var prevBtn = SLIDER.navigation && SLIDER.navigation.querySelector(".js-prev-btn") || SLIDER.outerNavigation && SLIDER.outerNavigation.querySelector(".js-prev-btn");
        var nextBtn = SLIDER.navigation && SLIDER.navigation.querySelector(".js-next-btn") || SLIDER.outerNavigation && SLIDER.outerNavigation.querySelector(".js-next-btn");
        SLIDER.sliderSettings.navigation = {};
        SLIDER.sliderSettings.navigation.prevEl = prevBtn;
        SLIDER.sliderSettings.navigation.nextEl = nextBtn;
      }
      if (!SLIDER.withoutPagination && SLIDER.pagination) {
        if (!SLIDER.sliderSettings.pagination) {
          SLIDER.sliderSettings.pagination = {};
        }
        SLIDER.sliderSettings.pagination.el = SLIDER.pagination;
        if (SLIDER.pagination.classList.contains("js-pagination-dots")) {
          SLIDER.sliderSettings.pagination.type = "bullets";
          SLIDER.sliderSettings.pagination.clickable = true;
        } else if (SLIDER.pagination.classList.contains("js-pagination-progress")) {
          SLIDER.sliderSettings.pagination.type = "progressbar";
          // SLIDER.sliderSettings.pagination.clickable = true;
        } else {
          SLIDER.sliderSettings.pagination.type = "fraction";
          SLIDER.sliderSettings.pagination.formatFractionCurrent = function (number) {
            var origin = number < 10 ? '0' : '';
            return origin + number;
          };
          SLIDER.sliderSettings.pagination.formatFractionTotal = function (number) {
            var origin = number < 10 ? '0' : '';
            return origin + number;
          };
          SLIDER.sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
            return "<span class='" + currentClass + "'></span>" + "/" + "<span class='" + totalClass + "'></span>";
          };
        }
      }
      if (SLIDER.scrollbar) {
        var scrollbar = SLIDER.el.querySelector(".swiper-scrollbar");
        SLIDER.sliderSettings.scrollbar = {};
        SLIDER.sliderSettings.scrollbar.el = scrollbar;
        SLIDER.sliderSettings.scrollbar.draggable = true;
      }
      if (SLIDER.dataDevice) {
        SLIDER.onWindowResize.call(SLIDER);
        itsoftApp.modules.windowResize.addEvent(SLIDER.onWindowResize.bind(SLIDER)); // TODO: проверить this
      } else {
        SLIDER.initSlider();
      }
    };
    new itsoftApp.modules.startLoad.callback(this.createSlider, itsoftApp.libraries.slider);
  };
  Slider.prototype.destroySlider = function () {
    this.initializedSlider.destroy(false, true);
    this.initializedSlider = undefined;
    this.isInitialized = false;
  };
  Slider.prototype.initSlider = function () {
    this.initializedSlider = new Swiper(this.sliderContainer, this.sliderSettings);
    if (this.initializedSlider) {
      if (this.currentSlide) {
        this.initializedSlider.slideTo(+this.currentSlide);
      }
      this.isInitialized = true;
    }
  };
  module.callback = Slider;
});
"use strict";

/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
  // Локальные переменные
  var module = this;
  module.initedSwipers = {};
  var Settings = {
    global: {
      slidesPerView: "auto",
      simulateTouch: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 500,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
          var sliderName = swiperContainer.getAttribute("data-slider-name") || "global";
          if (!module.initedSwipers.hasOwnProperty(sliderName)) {
            module.initedSwipers[sliderName] = swiper;
          }
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            sliderTrigger: sliderTrigger,
            sliderName: sliderName
          };
        }
      },
      breakpoints: {
        1024: {
          slidesPerView: 3
        }
      }
    },
    test: {
      slidesPerView: 1,
      simulateTouch: false,
      allowTouchMove: false,
      keyboard: {
        enabled: false,
        onlyInViewport: false
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      spaceBetween: 0,
      speed: 400,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
          swiper.params.custom = {
            requested: false
          };
        },
        slideChange: function slideChange() {
          var swiper = this;
          var activeSlide = swiper.slides[swiper.activeIndex];
          var inputWithNextStepExtraLabel = activeSlide.querySelector('[data-next-step-extra-label]');
          if (inputWithNextStepExtraLabel) {
            var nextSlide = swiper.slides[swiper.activeIndex + 1];
            nextSlide.classList.remove('_show-extra-label');
          }
        }
      }
    },
    composition: {
      slidesPerView: "auto",
      freeModeMomentum: false,
      speed: 500,
      // simulateTouch: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var slider = swiperContainer.closest('.js-slider');
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            slider: slider,
            sliderName: sliderName
          };
          var customParams = swiper.params.custom;
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
        }
      }
    },
    useProblem: {
      slidesPerView: "auto",
      freeModeMomentum: false,
      speed: 500,
      // simulateTouch: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var slider = swiperContainer.closest('.js-slider');
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            slider: slider,
            sliderName: sliderName
          };
          var customParams = swiper.params.custom;
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
        }
      }
    },
    actionProblem: {
      slidesPerView: "auto",
      freeModeMomentum: false,
      speed: 500,
      // simulateTouch: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var slider = swiperContainer.closest('.js-slider');
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            slider: slider,
            sliderName: sliderName
          };
          var customParams = swiper.params.custom;
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
        }
      }
    }
  };
  var getSettings = function getSettings(slidersSettingsKey) {
    return Settings[slidersSettingsKey];
  };
  module.getSettings = getSettings;
});
"use strict";

itsoftApp.createModule("startLoad", ["pageLoad"], function () {
  var module = this;
  var LibraryLoader = function LibraryLoader(func, library) {
    this.func = func;
    this.library = library;
    this.startLoad();
  };
  LibraryLoader.prototype.initQueue = function () {
    var LIBRARY_LOADER = this;
    if (!LIBRARY_LOADER.library.loaded) {
      return false;
    }
    if (!LIBRARY_LOADER.library.queue.length) {
      return;
    }
    DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] initQueue function fired, queue.length: " + LIBRARY_LOADER.library.queue.length);
    while (LIBRARY_LOADER.library.queue.length > 0) {
      // Взять первый элемент массива,
      // и вызвать его. Мы уже знаем, что это функция,
      // поэтому доп. проверка не требуется.
      LIBRARY_LOADER.library.queue.shift()();
    }
  };
  LibraryLoader.prototype.loadScriptStart = function (f) {
    var LIBRARY_LOADER = this;
    itsoftApp.loadScript(LIBRARY_LOADER.library.script, function () {
      DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] library loaded, ready to init queue");
      f();
    });
  };
  LibraryLoader.prototype.loadAndInit = function () {
    var LIBRARY_LOADER = this;
    var f = function f() {
      if (!LIBRARY_LOADER.library.loaded && LIBRARY_LOADER.library.cb && typeof LIBRARY_LOADER.library.cb === "function") {
        LIBRARY_LOADER.library.cb();
      }
      LIBRARY_LOADER.library.loaded = true;
      LIBRARY_LOADER.initQueue();
    };
    if (LIBRARY_LOADER.library.hasOwnProperty("style")) {
      itsoftApp.loadStyle(LIBRARY_LOADER.library.style);
    }
    if (LIBRARY_LOADER.library.hasOwnProperty("dependency") && LIBRARY_LOADER.library.dependency) {
      new itsoftApp.modules.startLoad.callback(function () {
        LIBRARY_LOADER.loadScriptStart(f);
      }, itsoftApp.libraries[LIBRARY_LOADER.library.dependency]);
    } else {
      LIBRARY_LOADER.loadScriptStart(f);
    }
  };
  LibraryLoader.prototype.addEvent = function () {
    var LIBRARY_LOADER = this;
    if (typeof this.func !== "function") {
      return;
    }

    // Если библиотека ещё не загружена, то добавляем в очередь
    if (!this.library.loaded) {
      // Если библиотека ещё не начала грузиться, то загружаем её
      // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
      if (!this.library.started) {
        this.library.started = true;
        DEBUG && console.log("%c--[module" + this.library.name + "] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
        itsoftApp.modules.pageLoad.addEvent(function () {
          LIBRARY_LOADER.loadAndInit();
        });
      }
      this.library.queue.push(this.func);
      DEBUG && console.log("[module " + this.library.name + "] function added, count of functions to init now: " + this.library.queue.length);

      // Если библиотека уже загружена, то просто вызываем переданную функцию
    } else {
      this.func();
    }
  };
  LibraryLoader.prototype.startLoad = function () {
    this.addEvent(this.func);
  };

  // Доступ к функциям
  // текущего модуля
  module.callback = LibraryLoader;
});
"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
itsoftApp.createModule("test", function () {
  var container = document.querySelector('#test');
  if (!container) {
    return;
  }
  var urlGlobal = null;
  var slider = null;
  var prevBtnEls = container.querySelectorAll('.js-test-btn-prev');
  var toggleEls = container.querySelectorAll(".js-test-toggle");
  var formEl = container.querySelector(".js-test-form");
  var startBtn = container.querySelector(".js-start-btn");
  var stepsNum = container.querySelectorAll('.js-test-num');
  var curStepIndex = 1;
  /**
   * Значение должно быть равно transition-delay у .test__slider .swiper-slide.swiper-slide-active в стилях
   */
  var delayChangeStepNum = 400;
  var processResults = function processResults(data) {
    var wrapper = document.createElement("div");
    wrapper.innerHTML = data;
    var resultData = wrapper.querySelector(".js-result");
    var res = document.querySelector('.test__wrapper');
    res.appendChild(resultData);
    container.classList.add('_end-test');
    var link = document.querySelector('.js-anchor-to-test-result');
    link.click();
    var testResetEl = container.querySelector(".js-test-reset");
    if (testResetEl) {
      testResetEl.addEventListener("click", resetTest);
    }
  };
  var resetTest = function resetTest(evt) {
    evt.preventDefault();
    var inputs = container.querySelectorAll(".js-test-toggle");
    Array.prototype.forEach.call(inputs, function (input) {
      input.checked = false;
    });
    curStepIndex = 1;
    slider.slideTo(0, 0);
    slider.params.custom.requested = false;
    slider.params.custom.nextStepRequest = false;
    var activeSlide = slider.slides[slider.activeIndex];
    activeSlide.style.transition = 'none';
    container.classList.remove('_end-test');
    container.classList.remove('_start-test');
    var resultData = container.querySelector(".js-result");
    resultData.remove();
    var _iterator = _createForOfIteratorHelper(stepsNum),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;
        el.innerHTML = '01';
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var link = document.querySelector('.js-anchor-to-test-start');
    link.click();
    setTimeout(function () {
      activeSlide.style.transition = '';
      container.classList.add('_start-test');
    }, 1);
  };
  var onErrorLoad = function onErrorLoad(data) {
    console.log("error ", data);
  };
  var sendRequest = function sendRequest(onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    slider.params.custom.createRequest = createRequest;
    xhr.addEventListener("load", function () {
      if (xhr.status === 200 && onSuccess) {
        onSuccess(xhr.response);
      } else {
        onError(xhr.response);
      }
    });
    xhr.addEventListener("error", function () {
      onError("Произошла ошибка соединения");
    });
    xhr.addEventListener("timeout", function () {
      onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
    });
    xhr.timeout = 10000;
    xhr.open("GET", urlGlobal);
    xhr.send();
  };
  var preResultActions = function preResultActions(resultValue) {
    var url = "?";
    var value = resultValue;

    // Array.prototype.forEach.call(allInputsValues, function (inputValue, index, arr) {
    //     value += inputValue.value[0];
    // });

    url += 'result' + "=" + value;
    url.replace(/\s/g, '+');
    var action = formEl.getAttribute("action");
    var query = action + url;

    // history.pushState("", "", url);
    urlGlobal = query;
    console.log(urlGlobal);
    sendRequest(processResults, onErrorLoad, true);
  };
  var debouncer = itsoftApp.utils.debouncer(preResultActions, 100);
  var calculateResult = function calculateResult(allInputsValues) {
    var result = 0;
    Array.prototype.forEach.call(allInputsValues, function (toggle) {
      result += parseInt(toggle.point, 10);
    });
    console.log(result);
    return result;
  };
  var createRequest = function createRequest() {
    var allInputsValues = [];
    var actualTestStepEls = container.querySelectorAll(".js-step-block");
    allInputsValues = Array.prototype.map.call(actualTestStepEls, function (stepBlock) {
      var allTestInputsEls = stepBlock.querySelectorAll(".js-test-toggle") || [];
      var allCheckedInputs = Array.prototype.filter.call(allTestInputsEls, function (item) {
        return item.checked;
      }) || [];
      return {
        name: allCheckedInputs.length > 0 ? stepBlock.getAttribute("name") || stepBlock.getAttribute("data-name") || allCheckedInputs[0].name : '',
        value: allCheckedInputs.length > 0 ? Array.prototype.map.call(allCheckedInputs, function (checkedTestInput) {
          return checkedTestInput.value;
        }) : '',
        point: allCheckedInputs.length > 0 ? Array.prototype.map.call(allCheckedInputs, function (checkedTestInput) {
          return checkedTestInput.getAttribute("data-point");
        }) : '0'
      };
    });
    var resultValue = calculateResult(allInputsValues);
    debouncer(resultValue);
  };
  var isLastStep = function isLastStep(target) {
    var slide = target.closest('.swiper-slide');
    var curIndex = _toConsumableArray(slider.slides).indexOf(slide) + 1;
    return curIndex === slider.slides.length;
  };
  var onToggleChange = function onToggleChange(evt) {
    var target = evt.target;
    var totalStepIndex = slider.slides.length;
    if (slider.params.custom.nextStepRequest || isLastStep(target)) {
      beforeRequest();
      return;
    }
    if (target.hasAttribute('data-next-step-last')) {
      var activeSlide = slider.slides[slider.activeIndex];
      var index = _toConsumableArray(slider.slides).indexOf(activeSlide) + 1;
      totalStepIndex = index + 1;
      slider.params.custom.nextStepRequest = true;
    }
    if (target.hasAttribute('data-next-step-extra-label')) {
      var nextSlide = slider.slides[slider.activeIndex + 1];
      nextSlide.classList.add('_show-extra-label');
    }
    curStepIndex += 1;
    var _iterator2 = _createForOfIteratorHelper(stepsNum),
      _step2;
    try {
      var _loop = function _loop() {
        var el = _step2.value;
        setTimeout(function () {
          el.innerHTML = "0".concat(curStepIndex, " / 0").concat(totalStepIndex);
        }, delayChangeStepNum);
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    slider.slideNext();
  };
  var beforeRequest = function beforeRequest() {
    if (!slider.params.custom.requested) {
      slider.params.custom.requested = true;
      createRequest();
    }
  };
  var onPrevBtnClick = function onPrevBtnClick(evt) {
    var activeSlide = slider.slides[slider.activeIndex];
    var inputs = activeSlide.querySelectorAll('.js-test-toggle');
    var checkedInput = _toConsumableArray(inputs).filter(function (el) {
      return el.checked;
    })[0];
    var totalStepIndex = slider.slides.length;
    if (checkedInput) {
      checkedInput.checked = false;
    }
    slider.params.custom.nextStepRequest = false;
    curStepIndex -= 1;
    slider.slidePrev();
    var _iterator3 = _createForOfIteratorHelper(stepsNum),
      _step3;
    try {
      var _loop2 = function _loop2() {
        var el = _step3.value;
        setTimeout(function () {
          el.innerHTML = curStepIndex === 1 ? '01' : "0".concat(curStepIndex, " / 0").concat(totalStepIndex);
        }, delayChangeStepNum);
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  };
  var init = function init() {
    Array.prototype.forEach.call(toggleEls, function (input) {
      input.addEventListener("click", onToggleChange);
    });
    Array.prototype.forEach.call(prevBtnEls, function (el) {
      el.addEventListener("click", onPrevBtnClick);
    });
  };
  if (startBtn) {
    startBtn.addEventListener("click", function (evt) {
      evt.preventDefault();
      if (!slider) {
        slider = Swiper.initedSliders["test"];
      }
      ;
      container.classList.add('_start-test');
    });
  }
  init();
});
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
itsoftApp.createModule("video", ['windowScroll'], function () {
  var module = this;
  var Video = function Video() {
    this.names = {
      canPlay: '_can-play',
      playing: '_playing',
      added: '_added'
    };
    this.offsetTop = 150;
    this.delayCheckLoad = 500;
    this.selectors = document.querySelectorAll('.js-video');
    if (this.selectors.length > 0) {
      this.init();
    }
  };
  Video.prototype.init = function () {
    var THIS = this;
    THIS.bindMethods();
    THIS.addListenerScroll();
    THIS.checkLoadAll();
    THIS.onScroll();
  };
  Video.prototype.bindMethods = function () {
    var THIS = this;
    THIS.scrollHandler = THIS.scrollHandler.bind(THIS);
  };
  Video.prototype.addListenerScroll = function () {
    var THIS = this;
    itsoftApp.modules.windowScroll.addEvent(THIS.scrollHandler);
  };
  Video.prototype.scrollHandler = function (e) {
    var THIS = this;
    THIS.onScroll(e);
  };
  Video.prototype.onScroll = function (e) {
    var THIS = this;
    var _iterator = _createForOfIteratorHelper(THIS.selectors),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;
        if (el.classList.contains('js-video-play-now') || el.classList.contains('js-video-autoplay-mobile') && THIS.isMobile()) {
          THIS.checkPlayNow(el);
        } else if (THIS.isBlockInWindow(el)) {
          THIS.checkPlayOnScroll(el);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  Video.prototype.checkPlayNow = function (el) {
    var THIS = this;
    THIS.addVideo(el);
    if (el.classList.contains(THIS.names.canPlay) && !el.classList.contains(THIS.names.playing)) {
      THIS.playVideo(el);
    } else {
      setTimeout(function () {
        if (THIS.getPos(el).bottom - window.innerHeight < 0 && el.classList.contains(THIS.names.canPlay) && !el.classList.contains(THIS.names.playing)) {
          THIS.playVideo(el);
        } else {
          THIS.checkPlayNow(el);
        }
      }, THIS.delayCheckLoad);
    }
  };
  Video.prototype.checkPlayOnScroll = function (el) {
    var THIS = this;
    if (el.classList.contains(THIS.names.canPlay) && !el.classList.contains(THIS.names.playing)) {
      THIS.playVideo(el);
    }
    if (el.classList.contains('js-video-mobile-hide') && window.innerWidth < 768) {} else {
      THIS.addVideo(el);
    }
  };
  Video.prototype.addVideo = function (el) {
    var THIS = this;
    if (!el.classList.contains(THIS.names.added)) {
      var source = document.createElement('SOURCE');
      if (window.innerWidth > 767 || !el.hasAttribute('data-src-mob')) {
        source.src = el.dataset.src;
      } else {
        source.src = el.dataset.srcMob;
      }
      source.type = 'video/mp4';
      el.appendChild(source);
      el.load();
      el.classList.add(THIS.names.added);
      THIS.checkLoad(el);
    }
  };
  Video.prototype.playVideo = function (el) {
    var THIS = this;
    if (!el.classList.contains('js-video-not-autoplay')) {
      el.oncanplaythrough = function () {
        el.play();
        el.classList.add(THIS.names.playing);
      };
    }
    if (el.classList.contains('js-video-autoplay-mobile') && THIS.isMobile()) {
      el.oncanplaythrough = function () {
        el.play();
        el.classList.add(THIS.names.playing);
      };
    }
  };
  Video.prototype.checkLoad = function (el) {
    var THIS = this;
    if (!el.classList.contains(THIS.names.canPlay) && el.classList.contains(THIS.names.added)) {
      el.classList.add(THIS.names.canPlay);
      if (!el.classList.contains('js-video-with-controls')) {
        el.removeAttribute('controls');
      } else {
        el.setAttribute("controlslist", "nodownload");
      }
    }
  };
  Video.prototype.checkLoadAll = function () {
    var THIS = this;
    var _iterator2 = _createForOfIteratorHelper(THIS.selectors),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var el = _step2.value;
        THIS.checkLoad(el);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  Video.prototype.isBlockInWindow = function (el) {
    var THIS = this;
    var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      bottom = _el$getBoundingClient.bottom;
    var pointTop = top - THIS.offsetTop;
    var pointBottom = bottom - THIS.offsetTop;

    // return pointTop < 0 && pointBottom > 0;
    return pointTop < window.innerHeight - 100 && pointBottom > 0;
  };
  Video.prototype.getPos = function (el) {
    var THIS = this;
    var _el$getBoundingClient2 = el.getBoundingClientRect(),
      top = _el$getBoundingClient2.top,
      bottom = _el$getBoundingClient2.bottom;
    var pointTop = top - THIS.offsetTop;
    var pointBottom = bottom - THIS.offsetTop;
    return {
      top: pointTop,
      bottom: pointBottom
    };
  };
  Video.prototype.isMobile = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };
  new Video();
  module.callback = Video;
});
"use strict";

itsoftApp.createModule("videoIntro", ["windowResize"], function () {
  var module = this;
  var VideoIntro = function VideoIntro() {
    this.names = {
      canPlay: "_can-play",
      playing: "_playing",
      added: "_added"
    };
    this.item = document.querySelector(".video-intro");
    this.bg = document.querySelector('.intro-product__bg');
    this.trigger = document.querySelector(".intro__video-trigger");
    this.videoPreview = this.trigger && this.trigger.querySelector("video");
    this.close = this.item && this.item.querySelector(".video-intro__close");
    this.video = this.item && this.item.querySelector("video");

    /**
     * Значение должно быть равно transition-duration у .video-intro в стилях
     */
    this.transitionDuration = 1000;
    this.delayCheckLoad = 500;
    this.play = false;
    if (this.item && this.trigger) {
      this.init();
    }
    if (!this.trigger && this.item) {
      this.item.style.display = 'none';
    }
  };
  VideoIntro.prototype.init = function () {
    var THIS = this;
    var rect = THIS.getRect();
    THIS.setClipPath(rect);
    THIS.item.style.transitionDuration = "0s";
    THIS.addListeners();
    var debouncedUpdate = itsoftApp.utils.debouncer(function () {
      THIS.onResize();
    }, 300);
    itsoftApp.modules.windowResize.addEvent(function () {
      debouncedUpdate();
    });
    THIS.item.style.display = "none";
  };
  VideoIntro.prototype.addListeners = function () {
    var THIS = this;
    THIS.onKeyDown = THIS.onKeyDown.bind(THIS);
    THIS.trigger.addEventListener("click", THIS.onTriggerClick.bind(THIS));
    THIS.close.addEventListener("click", THIS.onCloseClick.bind(THIS));
    if (!THIS.isMobile()) {
      THIS.trigger.addEventListener("mouseenter", THIS.onTriggerMouseEnter.bind(THIS));
      THIS.trigger.addEventListener("mouseleave", THIS.onTriggerMouseLeave.bind(THIS));
    }
  };
  VideoIntro.prototype.onKeyDown = function (e) {
    var THIS = this;
    if (e.keyCode === 27) {
      document.removeEventListener("keydown", THIS.onKeyDown);
      THIS.onCloseClick();
    }
  };
  VideoIntro.prototype.onTriggerClick = function (e) {
    var THIS = this;
    THIS.item.style.display = "";
    THIS.calcClipPath();
    THIS.play = true;
    THIS.setPadding("".concat(THIS.getScrollbarSize(), "px"));
    THIS.item.classList.add("_active");
    document.body.style.overflow = "hidden";
    THIS.item.style.transitionDuration = "";
    if (!THIS.video.classList.contains(THIS.names.added) && !THIS.video.classList.contains(THIS.names.canPlay)) {
      THIS.video.classList.add(THIS.names.added);
      var source = document.createElement('SOURCE');
      source.src = THIS.video.dataset.src;
      source.type = 'video/mp4';
      THIS.video.appendChild(source);
      THIS.video.load();
      THIS.checkLoad(THIS.video);
    } else {
      THIS.video.play();
    }
    if (window.lennis) {
      window.lennis.stop();
    }
    setTimeout(function () {
      document.addEventListener("keydown", THIS.onKeyDown);
      if (THIS.bg) {
        THIS.bg.style.display = 'none';
      }
    }, THIS.transitionDuration - 500);
  };
  VideoIntro.prototype.onTriggerMouseEnter = function (e) {
    var THIS = this;
    if (THIS.videoPreview.classList.contains("_can-play")) {
      THIS.trigger.classList.add("_active");
      THIS.videoPreview.play();
    }
  };
  VideoIntro.prototype.onTriggerMouseLeave = function (e) {
    var THIS = this;
    THIS.trigger.classList.remove("_active");
    THIS.videoPreview.pause();
    THIS.videoPreview.currentTime = 0;
  };
  VideoIntro.prototype.onCloseClick = function (e) {
    var THIS = this;
    THIS.play = false;
    THIS.item.classList.remove("_active");
    THIS.video.pause();
    if (THIS.bg) {
      THIS.bg.style.display = '';
    }
    setTimeout(function () {
      THIS.item.style.transitionDuration = "0s";
      document.body.style.overflow = "";
      THIS.video.currentTime = 0;
      if (window.lennis) {
        window.lennis.start();
      }
      THIS.setPadding("");
      THIS.item.style.display = "none";
    }, THIS.transitionDuration);
  };
  VideoIntro.prototype.onResize = function (e) {
    var THIS = this;
    THIS.calcClipPath();
  };
  VideoIntro.prototype.setClipPath = function (rect) {
    var THIS = this;
    THIS.item.style.clipPath = "circle(".concat(rect.width / 2, "px at ").concat(rect.left + THIS.trigger.clientWidth / 2, "px ").concat(rect.top + THIS.trigger.clientHeight / 2, "px)");
  };
  VideoIntro.prototype.checkLoad = function (el) {
    var THIS = this;
    if (!el.classList.contains(THIS.names.canPlay) && el.classList.contains(THIS.names.added)) {
      el.classList.add(THIS.names.canPlay);
      el.setAttribute("controlslist", "nodownload");
      if (!el.classList.contains(THIS.names.playing)) {
        THIS.playVideo(el);
      } else {
        setTimeout(function () {
          if (!el.classList.contains(THIS.names.playing)) {
            THIS.playVideo(el);
          }
        }, THIS.delayCheckLoad);
      }
    }
  };
  VideoIntro.prototype.playVideo = function (el) {
    var THIS = this;
    el.classList.add(THIS.names.playing);
    el.play();
  };
  VideoIntro.prototype.getRect = function () {
    var THIS = this;
    return THIS.trigger.getBoundingClientRect();
  };
  VideoIntro.prototype.calcClipPath = function () {
    var THIS = this;
    var rect = THIS.getRect();
    if (!THIS.play) {
      THIS.setClipPath(rect);
    }
  };
  VideoIntro.prototype.setPadding = function (property) {
    var header = document.querySelector(".l-header");
    var disclaimer = document.querySelector(".disclaimer");
    var cookie = document.querySelector(".cookies");
    document.body.style.paddingRight = property;
    if (header) {
      header.style.paddingRight = property;
    }
    if (disclaimer) {
      disclaimer.style.paddingRight = property;
    }
    if (cookie) {
      cookie.style.paddingRight = property;
    }
  };
  VideoIntro.prototype.getScrollbarSize = function () {
    return window.innerWidth - document.body.offsetWidth;
  };
  VideoIntro.prototype.isMobile = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };
  new VideoIntro();
  module.callback = VideoIntro;
});
// itsoftApp.createModule("videoPopup", ["popups"], function () {
//     const module = this;
//     const videoEls = document.querySelectorAll("video");

//     if (videoEls.length > 0) {
//         videoEls.forEach(function (videoEl) {
//             videoEl.setAttribute("controlslist", "nodownload");
//         });
//     }

//     const VideoPopup = function (triggerButton, popup) {
//         this.triggerButton = triggerButton;
//         this.popup = popup;
//         this.video = popup.querySelector("video");

//         this.init();
//     }

//     VideoPopup.prototype.init = function () {
//         const VIDEO_POPUP = this;
//         const popup = VIDEO_POPUP.popup;
//         const video = VIDEO_POPUP.video;

//         this.onPopupOpenListener = this.onPopupOpen.bind(VIDEO_POPUP);
//         this.onPopupCloseListener = this.onPopupClose.bind(VIDEO_POPUP);
//         // this.onVideoPlayListener = this.onVideoPlay.bind(VIDEO_POPUP);

//         popup && popup.addEventListener("popups:open", this.onPopupOpenListener);
//         popup && popup.addEventListener("popups:close", this.onPopupCloseListener);

//         // popup.dispatchEvent(window.openEvent);
//         // video.addEventListener("click", onVideoPlayListener);
//     }

//     VideoPopup.prototype.onPopupOpen = function (evt) {
//         const VIDEO_POPUP = this;
//         VIDEO_POPUP.video.play();
//         VIDEO_POPUP.video.classList.add("js-active");

//     }

//     VideoPopup.prototype.onPopupClose = function (evt) {
//         const VIDEO_POPUP = this;
//         VIDEO_POPUP.video.pause();
//         VIDEO_POPUP.video.classList.remove("js-active");
//     }

//     const videoPopupInit = function (triggerButton) {
//         const popup = document.querySelector("#" + triggerButton.getAttribute("data-popup-id"));

//         new VideoPopup(triggerButton, popup);
//     }

//     module.init = videoPopupInit;
// });
"use strict";
"use strict";

/**
 * Общая точка входа
 * для события изменения размеров экрана.
 *
 * NOTE: Событие на практике происходит редко
 * (например, поворот планшета или телефона, или равзернуть окно на полный экран на десктопе),
 * поэтому мы будем "выполнять" его с помощью debouncer
 * (отложенное выполнение).
 */
itsoftApp.createModule("windowResize", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var $window = itsoftApp.commonVars.$window;

  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   *
   * Вызываем обработчик через debouncer (задержка по выполнению),
   * чтобы функции из массива не вызывались слишком часто.
   */
  var resizeController = itsoftApp.utils.debouncer(function () {
    if (!events.length) {
      return;
    }
    var f, i, len;
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth) {
      itsoftApp.utils.getViewportSize();
    }
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewHeight) {
      itsoftApp.utils.getViewportHeight();
    }
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight) {
      itsoftApp.utils.getHeaderHeight();
      itsoftApp.utils.getHeaderFixedHeight();
      itsoftApp.utils.getHeaderStaticHeight();
    }
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
      itsoftApp.utils.getDisclaimerHeight();
    }
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.cookieHeight) {
      itsoftApp.utils.getCookieHeight();
    }
    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f();
    }
  });

  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "resize" окна браузера.
   *
   * @param {function} func
   */
  var addEvent = function addEvent(func, name) {
    if (typeof func !== "function") {
      return;
    }
    var _method = function method(action) {
      if (action) {
        var index = events.indexOf(_method);
        if (index !== -1) {
          events.splice(index, 1);
          DEBUG && console.log("".concat(name, " \u0443\u0434\u0430\u043B\u0451\u043D"));
        }
      } else {
        func();
      }
    };
    events.push(_method);
    DEBUG && console.log("[module windowResize] function added, count of functions to init now: " + events.length);
    return _method;
  };

  // Привязка события и обработчика
  $window.addEventListener("resize", resizeController);

  // Доступ к фукциям
  // текущего модуля
  module.addEvent = addEvent;
});
"use strict";

/**
 * Общая точка входа
 * для события скролла страницы.
 *
 * NOTE: Контроллер будет передавать текущее значение скролла
 * каждой из переданных в данный модуль функций.
 */
itsoftApp.createModule("windowScroll", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var enabled = false;
  var $window = itsoftApp.commonVars.$window;

  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   */
  var scrollController = function scrollController() {
    if (!enabled) {
      return;
    }
    var y = document.body.scrollTop || document.documentElement.scrollTop;
    var f, i, len;
    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f.call(this, y);
    }
  };

  /**
   * Привязка события и контроллера.
   * Вынесено в отдельную функцию, так как если модулю не передана ни одна функция на событие "scroll"
   * то и общий обработчик вешать нет смысла.
   * Сделано для оптимизации производительности (небольшая прибавка).
   */
  var bind = function bind() {
    $window.addEventListener("scroll", scrollController, {
      passive: true
    });
  };

  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "scroll".
   *
   * @param {function} func
   */
  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }
    if (!enabled) {
      enabled = true;
      bind();
    }
    events.push(func);
    DEBUG && console.log("[module windowScroll] function added, count of functions to init now: " + events.length);
  };

  // Доступ к фукциям
  // текущего модуля
  module.addEvent = addEvent;
});